import react, { Dispatch, SetStateAction, useEffect, useMemo, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { botAnalysis, botSearchRecommendation, follow_up_question, getBotConfigurations, gift_recommendation, memoryClear, getRecommendationsStyleIdeas, bundlingSuggestion, getAnswer, getHandler, user_story_bundling_api, getAnswerTest, vc_csv_upload, vc_room_upload } from 'services/chatBotService';
import { handBotleLoader, setBotProduct, addProductPageQuestion, updateProductPageQuestion, resetProductPageQuestion, setUserHandlerName, setIsNewConversation, addOrRemoveObjectForAddToCart, handleAnswerCalling, setStopId } from 'redux/counterSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { getVerifiedEmail, login } from "services/coversationService";
import _, { chunk, result } from "lodash";
import { toast, ToastContent } from "react-toastify";
import { CloseEyeIcon, chatBotRefresh, eyeIcon, searchSend, LinkIcon, LinkIconWhite, StarFill, StarEmplty, cancelIcon, ProductAdd, CloseIcon, ChooseIcon, searchMicActive, searchMic, shopMateIcon, DeleteRed, leftIcon, rightIcon, add, zoomIn, micWhite, speakerIcon } from "assets/icons";
import defaultImg from "assets/images/default-img.png";
import { addQuestion, controlHandlerState, handleBotLoginQue, handleIsUserHandler, resetQuestion, setSuggestionList, updateQuestion } from "redux/persistentSlice";
import ReactMarkdown from 'react-markdown';
import styles from 'assets/styles/ai-chat-bot/markdownRenderer.module.css';
import CryptoJS from 'crypto-js';
import * as myconst from "../../constants/index"
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import { Carousel, CarouselResponsiveOption } from "primereact/carousel";
import { Checkbox } from "primereact/checkbox";
import VoiceSearch from "components/VoiceSearch";
import React from "react";
import Cookies from 'js-cookie';
import { Badge } from "primereact/badge";
import remarkGfm from 'remark-gfm';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import proImg from "assets/images/pro-img.jpg";
import uploadVector from "assets/images/upload-vector.svg";
import infoImg from "assets/images/info-img.svg";
import genratedImg from "assets/images/genrated-img.jpg";
import LightBoxImg from "assets/images/light-box-img.jpg";
import aiAnim from "assets/images/ai-anim.svg";
import aiAnimTxt from "assets/images/ai-anim-txt.svg";

import Lightbox from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import "yet-another-react-lightbox/styles.css";

interface ChartObject {
    test: string;
    setTest: any;
    errored: boolean;
    setError: Dispatch<SetStateAction<boolean>>;
    typePassword: boolean;
    setTypePassword: any
    chatHeight: boolean;
    isPreview: string;
    botName: string;
    tagline: string;
    initialMessage: string;
    botLogo: string;
    avatarLogo: string;
    headerColor: string;
    questionBackgroundColor: string;
    answerBackgroundColor: string;
    fontSize: number;
    followUP: boolean;
    setFollowUP: Dispatch<SetStateAction<boolean>>;

}

interface QueryObject {
    Question: string;
    SQLQuery: string;
    Ans: string;
}

type BotConfigurationResponse = {
    bot_name: string | null,
    organization_info: {
        organization_name: string,
        organization_url: string,
        domain_name: string,
        description: string
    },
    bot_config: {
        bot_name: string,
        tagline: string,
        initial_message: string,
        bot_logo: string,
        bot_logo_name: string,
        avtar_logo_name: string,
        avatar_logo: string,
        header_colour: string,
        question_background_colour: string,
        answer_background_colour: string,
        font_type: string,
        font_size: number
    },
    db_credentials_info: {
        csv_data: string,
        csv_name: string,
        host: string,
        port: number,
        user_name: string,
        password: string,
        db_name: string,
        tables: string[]
    },
    question_answer_info: {
        Question_Answer: QueryObject[],
    },
    config_info_change: {
        temperature: number,
        max_token: number
    },
    spipeet_info: {
        snipeet_code: string
    },
    is_config_info: boolean,
    is_question_answer: boolean,
    is_file: boolean,
    created_by: string
}

interface Product {
    code: string,
    name: string,
    image: string,
    price: number,
    description: string,
    category: string,
    subcategory?: string,
    brand?: string,
    rating?: number,
    no_of_rating?: number,
    no_of_reviews?: number,
    color: string,
    gender?: string,
    size?: string
}
interface ProductTemplateProps {
    product: Product;
    products: Product[];
}

const ImageWithFallback = ({ src, alt, styles, fallbackSrc }: { src: string, alt: string, styles?: any, fallbackSrc: any }) => {
    const [imageSrc, setImageSrc] = useState(src);
    const [hasErroredOnce, setHasErroredOnce] = useState(false);
    useEffect(() => {
        if (!src) return;

        const img = new Image();
        img.src = src;

        img.onload = () => {
            setImageSrc(src); // Only set if it successfully loads
        };

        img.onerror = () => {
            setImageSrc(fallbackSrc); // Fall back if it fails to load
        };
    }, [src, fallbackSrc]);


    const handleError = () => {
        // setImageSrc(defaultImg);
        if (!hasErroredOnce) {
            setHasErroredOnce(true);
            setImageSrc(fallbackSrc); // Try default image if main fails
        }
    };
    return (
        <img
            src={imageSrc}
            alt={alt}
            onError={handleError}
            style={styles}
        />
    );
};

const ChatBot1 = ({ test, setTest, errored, setError, followUP, setFollowUP, typePassword, setTypePassword, chatHeight, isPreview, botName, tagline, initialMessage, botLogo, avatarLogo, headerColor, questionBackgroundColor, answerBackgroundColor, fontSize }: ChartObject) => {
    const dispatch = useDispatch<AppDispatch>();
    const lensInputRef: any = useRef(null);
    const fileInputRef: any = useRef(null);
    const scrollRef = useRef<HTMLDivElement>(null);
    const botLoader = useSelector((state: any) => state.counter.botLoader);
    const isAnswerCalling = useSelector((state: any) => state.counter.isAnswerCalling);
    const userHandlerName = useSelector((state: any) => state.counter.userHandlerName);
    const isNewConversation = useSelector((state: any) => state.counter.isNewConversation);
    const addToCartObj = useSelector((state: any) => state.counter.addToCartObj);
    const handlerState = useSelector((state: any) => state.persistent.handlerState);
    const isUserHandler = useSelector((state: any) => state.persistent.isUserHandler);
    const addToCartProducts = localStorage.getItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`);
    // const addToCartProducts = Cookies.get(`addToCartProducts${localStorage.getItem('username')}`);
    const addToCartProductsParse = addToCartProducts !== undefined && addToCartProducts !== null ? JSON.parse(addToCartProducts as any) : [];
    const [cartpageVisible, setCartPageVisible] = useState<boolean>(false);
    const [roomImage, setRoomImage] = useState<string>('');
    const [roomImage2, setRoomImage2] = useState<string>('');
    const [productList, setProductList] = useState<any>([])
    const [productCartList, setProductCartList] = useState<any>([])
    const [singleProduct, setSingleProduct] = useState<any>([])
    const [cartProducts, setCartsProduct] = useState<any>(addToCartProductsParse);
    const [productCompareList, setProductCompareList] = useState<any>([])

    // Ensure all cart products have quantity property
    useEffect(() => {
        const updatedProducts = cartProducts.map((product: any) => ({
            ...product,
            quantity: product.quantity || 1
        }));
        if (JSON.stringify(updatedProducts) !== JSON.stringify(cartProducts)) {
            setCartsProduct(updatedProducts);
            localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(updatedProducts));
        }
    }, []);
    // const [showSuggestions, setShowSuggestions] = useState(false);
    const [styledIdeaProducts, setStyledIdeaProducts] = useState<any>([])
    const [bundlingSuggestionProducts, setBundlingSuggestionProducts] = useState<any>([])
    const [botProduct, setBotProduct] = useState("");
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);
    // const [activeProduct, setActiveProduct] = useState("");
    const [linkIconsHover1, setLinkIconHover1] = useState(LinkIcon)
    const [linkIconsHover2, setLinkIconHover2] = useState(LinkIcon)
    const messagesEndRef = useRef<HTMLInputElement>(null);
    const messages = useSelector((state: any) => state.persistent.messages);
    const suggestionList = useSelector((state: any) => state.persistent.suggestionList);
    const productPageMessages = useSelector((state: any) => state.counter.productPageMessages)
    const botLoginQue = useSelector((state: any) => state.persistent.botLoginQue);
    // const botProduct = useSelector((state: any) => state.counter.botProduct);
    const token = localStorage.getItem("chat_access_token");
    const chatUserName = localStorage.getItem("chatUserName");
    const [message, setMessage] = useState<string>("");
    const [currentActivePage, setCurrentActivePage] = useState<string>("detail");
    const [showPassword, setShowPassword] = useState(false);
    const [toggleAddProducts, setToggleAddProducts] = useState<boolean>(false);
    // const [test, setTest] = useState<string>("");
    const [sendOtp, setSendOtp] = useState<string>("");
    const [chatToken, setChatToken] = useState(token ? token : "");
    const [chatName, setChatName] = useState(chatUserName ? chatUserName : "");
    const [data, setData] = useState<BotConfigurationResponse>();
    const [botl, setBotl] = useState<any>("");
    const [avtarl, setAvtarl] = useState<any>("");
    const [addedCompare, setAddedCompare] = useState<string>("");
    const [addToCart, setAddToCart] = useState<string>("");
    const [addToCartBtnName, setAddToCartBtnName] = useState<string>("Add to Cart");
    const [fontSize1, setFontSize1] = useState<any>();
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [activeIndexStyledProduct, setActiveIndexStyledProduct] = useState<number>(0);
    const [activeIndexBundleProduct, setActiveIndexBundleProduct] = useState<number>(0);
    let featureHistory: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    const VoiceSearchFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.voiceSearch]
    const [isKeyDown, setIsKeyDown] = useState(false);
    const inputbox: any = document.querySelector('.input-box');
    const sendButton: any = document.querySelector('#send-button');
    const inputRef: any = useRef(null);
    const productDetailPageRef: any = useRef(null);
    const [lastProductId, setLastProductId] = useState<any>(null);
    const [open, setOpen] = useState(false);
    const [videoImage, setVideoImage] = useState<any>([]);
    let chunkedStyledIdeaProducts = styledIdeaProducts?.length > 3 ? chunk(styledIdeaProducts, 3) : [styledIdeaProducts];
    const voiceSearch = VoiceSearch(
        setIsKeyDown,
        inputbox,
        sendButton,
        setMessage,
    );
    const handleStartListening = voiceSearch.handleStartListening;

    const responsiveOptions: CarouselResponsiveOption[] = [
        {
            breakpoint: '479px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '380px',
            numVisible: 1,
            numScroll: 1
        }
    ];
    const stopId = useSelector((state: any) => state.counter.stopId);
    const handleChange = (e: any) => {
        if (!showPassword && typePassword) {
            setMessage(e.target.value.trim());
        } else {
            setMessage(e.target.value);
        }
    }
    const handleLensToggle = () => {
        // Trigger the file input when the button is clicked
        lensInputRef.current.click();
    };

    const handleLensChange = async (event: any) => {
        const file = event.target.files[0];
        const size = Number(event?.target?.files[0]?.size / 1048576);
        if (file) {
            if (size < 10 && file.size > 0) {
                if (file && myconst.imageTypes.includes(file.type)) {
                    const base64Code: any = await myconst.fileToBase64(file)
                    const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                    setVideoImage([])
                    setRoomImage(correctBase64);
                    setRoomImage2(base64Code);
                }
            } else {
                toast.error("File size should not be more than 10 MB", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                lensInputRef.current.value = ""
            }
        }
    }

    useEffect(() => {
        if (localStorage.getItem("clientName") === "InzaloEMS") {
            // dispatch(setBotProduct("ProductSearch"));
        }
    }, []);

    // Check scroll position on mount and scroll
    const checkScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        setShowLeft(el.scrollLeft > 0);
        setShowRight(Math.round(el.scrollLeft) + el.clientWidth < el.scrollWidth - 1);
    };
    // Update visibility on mount and when content changes
    useEffect(() => {
        checkScroll();
        const el = scrollRef.current;
        if (!el) return;

        el.addEventListener('scroll', checkScroll);
        window.addEventListener('resize', checkScroll); // Re-check on resize

        return () => {
            el.removeEventListener('scroll', checkScroll);
            window.removeEventListener('resize', checkScroll);
        };
    }, [suggestionList, isAnswerCalling, productList, cartpageVisible]);

    // Reset scroll position when suggestionList changes
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollLeft = 0;
        }
    }, [suggestionList, isAnswerCalling]);

    const scrollLeft = () => {
        scrollRef.current?.scrollBy({ left: -200, behavior: 'smooth' });
    };

    const scrollRight = () => {
        scrollRef.current?.scrollBy({ left: 200, behavior: 'smooth' });
    };
    const renderStars = (rating: any) => {
        const fullStars = Math.floor(rating); // Full stars
        const fractionalPart = rating % 1;

        let quarterStar = 0;
        let threeQuarterStar = 0;
        let halfStar = 0;

        if (fractionalPart >= 0.75) {
            threeQuarterStar = 1;
        } else if (fractionalPart >= 0.5) {
            halfStar = 1;
        } else if (fractionalPart >= 0.25) {
            quarterStar = 1;
        }
        const emptyStars = 5 - fullStars - quarterStar - halfStar - threeQuarterStar;
        return (
            <div className="stars">
                <div className="star-wrapper">
                    {[...Array(fullStars)]?.map((_, i) => (
                        <i key={`full-${i}`} className="fa fa-star full-star_bot" />
                    ))}

                    {threeQuarterStar === 1 && (<i key="threeQuarter" className="fa fa-star three-quarter-star_bot" />)}

                    {halfStar === 1 && (
                        <i key="half" className="fa fa-star half-star_bot" />
                    )}

                    {quarterStar === 1 && (<i key="quarter" className="fa fa-star quarter-star_bot" />)}

                    {[...Array(emptyStars)]?.map((_, i) => (
                        <i key={`empty-${i}`} className="fa fa-star empty-star_bot" />
                    ))}
                </div>
            </div>
        )
    }

    const roomUpload = async (input_image_light_url: string) => {
        if (roomImage2 !== "") {
            dispatch(handBotleLoader(true))
            const urlToBase64 = await myconst.convertImageUrlToBase64(input_image_light_url);
            const givingBase64 = await myconst.manipulateBase64Data(urlToBase64);
            try {
                const body = {
                    client_env: localStorage.getItem('clientName'),
                    bot_name: 'shoptalk',
                    user_name: localStorage.getItem('username'),
                    conversation_id: localStorage.getItem('botId'),
                    room: roomImage,
                    input_image_light_url: givingBase64,
                }
                const { result, error } = await vc_room_upload(body);
                if (error || result?.error) {
                    throw error || result.error;
                }
                const currentUrl = window.location.origin === 'https://shoptalk.rysun.com' ? 'https://shoptalkvcwebapp.rysun.in' : 'http://43.242.38.39'
                const arr = [
                    { src: `${currentUrl}/${result.generated_image_path.replace("/opt", "")}`, alt: 'Room Image with Product' },
                    {
                        type: "video",
                        // width: 1280,
                        // height: 720,
                        poster: `${currentUrl}/${result.generated_image_path.replace("/opt", "")}`,
                        sources: [{
                            src: `${currentUrl}/${result.generated_video_path.replace("/opt", "")}`,
                            type: "video/mp4",
                        }],
                        autoPlay: false,
                        controls: true,
                    },
                ]
                setVideoImage(arr)
                dispatch(handBotleLoader(false));
                console.log("result", result)
            } catch (error: unknown) {
                dispatch(handBotleLoader(false));
                toast.error(error as ToastContent<unknown>, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            }
        } else {
            toast.error('Please select your room images' as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });

        }
    }

    const productTemplate = (product: any, products: any) => {
        const index = products.indexOf(product);
        const isInCart = cartProducts.some((newProduct: any) => product.code === newProduct.code);

        const handleAddToCartClick = (e: any) => {
            e.stopPropagation();
            if (!isInCart) {
                handleAddToCart(product);
                toast.success(`${product.name} added to cart!`, {
                    style: {
                        backgroundColor: '#F1F1F1',
                    }
                });
            } else {
                toast.info(`${product.name} is already in your cart!`, {
                    style: {
                        backgroundColor: '#F1F1F1',
                    }
                });
            }
        };

        return (
            <div className={`product-card`} id={product.code}>
                {/* <div className={`product-card ${activeProduct === product.link ? "active" : ""}`} id={product.link}> */}
                <div className="product-card-wrap" id={index} onClick={() => {
                    setActiveIndexBundleProduct(0)
                    hanldeProductDetail(product, products);
                    setActiveIndex(index);
                }}>
                    <figure>
                        <span><ImageWithFallback src={product.image !== null ? product.image : defaultImg} fallbackSrc={defaultImg} alt={product.name} /></span>
                        <figcaption>
                            <p title={product.name}>{product.name?.length > 20 ? `${product.name.slice(0, 20)}...` : product.name}</p>
                            <i
                                className="pi pi-shopping-cart"
                                onClick={handleAddToCartClick}
                                style={{
                                    cursor: 'pointer',
                                    opacity: isInCart ? 0.5 : 1,
                                    pointerEvents: 'auto',
                                    fontSize: '1.4rem',
                                    color: 'white'
                                }}
                            ></i>
                        </figcaption>
                    </figure>
                </div>
            </div>
        );
    };
    const productDetailTemplate = (product: Product) => {
        // setProductObject(product)
        return (
            <>
                {/* <div className={`product-card ${activeProduct === product.title ? "active" : ""}`} id={product.title}>
                    <div className="product-card-wrap">
                        <figure>
                            <span><img src={product.link} alt={product.title} /></span>
                            <figcaption onClick={() => { hanldeProductDetail(product); setActiveProduct(product.title) }}><p title={product.title}>{product.title.length > 24 ? `${product.title.slice(0, 24)}...` : product.title}</p><i><img src={LinkIconWhite} alt="link-icon" /></i></figcaption>
                        </figure>
                    </div>
                </div> */}
                <div className="product-top">
                    <figure>
                        <ImageWithFallback src={product.image !== null ? product.image : defaultImg} fallbackSrc={defaultImg} alt={product.name} />
                        {/* <img src={product.link} alt={product.title} /> */}
                    </figure>
                </div>
            </>
        );
    };

    const handleSpeak = async (screenText: any, id: any) => {
        if (!screenText || typeof screenText !== "string") {
            return;
        }

        // Stop any currently playing audio
        if (currentAudioRef.current) {
            currentAudioRef.current.pause();
            currentAudioRef.current = null;
            dispatch(setStopId(""));
        }

        // ⛔ Remove emojis from spoken text  
        const cleanedText = screenText.replace(
            /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|\p{Emoji})/gu,
            ""
        ).trim();

        if (!cleanedText) {
            return;
        }

        // Get Eleven Labs API credentials
        const ELEVEN_API_KEY = process.env.REACT_APP_ELEVEN_API_KEY || "sk_c5bec5006110e4001363ba70636ba4e37d9f6eb1bf54cc7b";
        const ELEVEN_MODEL = process.env.REACT_APP_ELEVEN_MODEL || "eleven_multilingual_v2";
        const VOICE_ID = process.env.REACT_APP_ELEVEN_VOICE_ID || "19STyYD15bswVz51nqLf";

        if (!ELEVEN_API_KEY || !VOICE_ID) {
            console.error('ElevenLabs API credentials not configured');
            return;
        }

        // Use Eleven Labs API
        if (stopId !== id) {
            try {
                dispatch(setStopId(id));

                // Call ElevenLabs API
                const response = await fetch(
                    `https://api.elevenlabs.io/v1/text-to-speech/${VOICE_ID}`,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'audio/mpeg',
                            'Content-Type': 'application/json',
                            'xi-api-key': ELEVEN_API_KEY,
                        },
                        body: JSON.stringify({
                            text: cleanedText,
                            model_id: ELEVEN_MODEL,
                            language_code: 'en',
                            voice_settings: {
                                stability: 0.5,
                                similarity_boost: 0.75,
                                style: 0.0,
                                use_speaker_boost: true
                            }
                        }),
                    }
                );

                if (!response.ok) {
                    throw new Error(`ElevenLabs API error: ${response.status} ${response.statusText}`);
                }

                // Get audio blob from response
                const audioBlob = await response.blob();
                const audioUrl = URL.createObjectURL(audioBlob);

                // Create and play audio
                const audio = new Audio(audioUrl);
                currentAudioRef.current = audio;

                audio.onended = () => {
                    URL.revokeObjectURL(audioUrl);
                    currentAudioRef.current = null;
                    dispatch(setStopId(null));
                };

                audio.onerror = (error) => {
                    console.error('Error playing audio:', error);
                    URL.revokeObjectURL(audioUrl);
                    currentAudioRef.current = null;
                    dispatch(setStopId(null));
                };

                await audio.play();
            } catch (error: any) {
                console.error('Error with ElevenLabs TTS:', error);
                dispatch(setStopId(null));
                currentAudioRef.current = null;
            }
        }
    };

    const fetchTextOnly = (result: any) => {
        if (result?.answer && typeof result?.answer === "string") {
            return result?.answer;
        }
        if (result?.message && typeof result?.message === "string") {
            return result?.message;
        }
        return "";
    }

    const handleAnswerResponse = (uid: any, message: any, ans: string) => {
        handleSpeak(ans, uid)
        setTimeout(() => {
            dispatch(
                updateQuestion({ id: uid, question: message, answer: ans, isTyping: "Done", isCsv: "", productType: "product_search" })
            );
            dispatch(handleAnswerCalling(false));
        }, 1000)
    }
    const handleAnswerResponseAdd = (uid: any, message: any, ans: string) => {
        handleSpeak(ans, uid)
        setTimeout(() => {
            dispatch(
                addQuestion({ id: uid, question: message, answer: ans, isTyping: "Done", isCsv: "", productType: "product_search" })
            );
        }, 2000)
    }
    const replaceAllWithAsterisks = (str: string) => {
        return str.replace(/./g, '*');
    };
    const secretKey = 'RON__USER__LOGIN';
    const iv = 'BBBBBBBBBBBBBBBB';
    // Function to encrypt the password
    const encryptPassword = (password: string) => {
        const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.ECB
        });
        return encrypted.toString();
    };

    const userHandler: any = Cookies.get(`handler_${localStorage.getItem('username')}`); // Retrieve 'user' cookie
    const firstTimeHandle = async (uniqueId: string, message2: string, validationMessage: string) => {
        try {
            const { result, error } = await getHandler("", "");
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            await handleAnswerResponse(uniqueId, message2, `${validationMessage} **${result.handler_name}**.`);
            const uniqueId2 = uuidv4();
            await handleAnswerResponseAdd(uniqueId2, "", `Would you like to update your handle to one of your choice? Please respond with "Yes" or "No".`)
            dispatch(controlHandlerState("no_state"));
            dispatch(setUserHandlerName(result.handler_name));
            dispatch(handleAnswerCalling(false));
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleClickMessage = async () => {
        if (message) {
            // Stop any currently playing audio
            if (currentAudioRef.current) {
                currentAudioRef.current.pause();
                currentAudioRef.current = null;
                dispatch(setStopId(''));
            }
            // if (userHandler !== undefined) {
            //     dispatch(handleIsUserHandler(true));
            // }
            dispatch(handleAnswerCalling(true));
            setMessage("");
            const uniqueId = uuidv4();
            if (!errored && productList?.length === 0 && productCartList?.length === 0) {
                dispatch(
                    addQuestion({ id: uniqueId, question: message, answer: "", isTyping: "Typing" })
                );
            }
            let Client: string | null = "";
            const env = localStorage.getItem("clientName")
            if (window.location.origin === 'https://ron.rysun.in:3001' && env === "ron_prod") {
                Client = "frida_prod"
            } else if (window.location.origin !== 'https://ron.rysun.in:3001' && (env === "ron_stage" || env === "ron_dev")) {
                Client = "frida"
            } else {
                if (localStorage.getItem("envParam") === "Firstwatch") {
                    Client = "Firstwatch"
                } else {
                    Client = env
                }
            }
            let botId = localStorage.getItem("botId") || "";
            // if (userHandler === undefined) {
            //     if (localStorage.getItem('username') === undefined || localStorage.getItem('username') === null) {
            //         // localStorage.clear()
            //         localStorage.removeItem('access_token');
            //         localStorage.removeItem('announcements');
            //         //localStorage.removeItem('clientName');
            //         localStorage.removeItem('default_label');
            //         localStorage.removeItem('default_questions');
            //         localStorage.removeItem('feature-flag');
            //         localStorage.removeItem('firstName');
            //         localStorage.removeItem('isLogged');
            //         localStorage.removeItem('lastActivity');
            //         localStorage.removeItem('lastName');
            //         localStorage.removeItem('loginTime');
            //         localStorage.removeItem('logos');
            //         localStorage.removeItem('permissions');
            //         localStorage.removeItem('refresh_token');
            //         localStorage.removeItem('username');
            //         localStorage.removeItem('lastBotQuestion');
            //         localStorage.removeItem('botId');
            //         localStorage.removeItem("wrongAttempt");
            //         localStorage.removeItem("attempt");
            //         localStorage.removeItem('handler_name_exist');
            //         localStorage.removeItem("false_attempt");
            //         localStorage.removeItem("user_name_attempts")
            //         localStorage.removeItem("chatUserName");
            //         localStorage.removeItem("chat_access_token");
            //         window.location.href = '/login'
            //     }
            //     dispatch(setIsNewConversation("old"));
            //     // if (myconst.noSynonyms.some((i: string) => message.toLowerCase().includes(i)) && handlerState === "") {
            //     if (myconst.noSynonyms.includes(message.toLowerCase()) && handlerState === "") {
            //         firstTimeHandle(uniqueId, message, "To personalize your chat experience, we have assigned you a handle:");
            //         // } else if (myconst.yesSynonyms.some((i: string) => message.toLowerCase().includes(i)) && handlerState === "") {
            //     } else if (myconst.yesSynonyms.includes(message.toLowerCase()) && handlerState === "") {
            //         handleAnswerResponse(uniqueId, message, `Please provide your handle. You have 2 attempts to enter a valid handle.`);
            //         dispatch(controlHandlerState("yes_state"));
            //         dispatch(handleAnswerCalling(false));
            //         // handleAnswerResponse(uniqueId, message, "Kindly provide the correct display name to submit your questions.")
            //     } else {
            //         if (handlerState === "") {
            //             const wrongAttempt = localStorage.getItem("wrongAttempt");
            //             if (wrongAttempt === null) {
            //                 localStorage.setItem("wrongAttempt", '1')
            //                 handleAnswerResponse(uniqueId, message, `Please provide a valid response. You have only 1 attempt remaining.`);
            //                 dispatch(handleAnswerCalling(false));
            //             } else if (wrongAttempt === '1') {
            //                 handleAnswerResponse(uniqueId, message, `You have entered an incorrect response twice, exceeding the allowed limit.`);
            //                 const uniqueId2 = uuidv4();
            //                 setTimeout(() => {
            //                     dispatch(
            //                         addQuestion({ id: uniqueId2, question: "", answer: "", isTyping: "Typing" })
            //                     );
            //                     firstTimeHandle(uniqueId2, "", "To ensure a seamless experience, we have now assigned you a new handle:");
            //                     localStorage.removeItem("wrongAttempt");
            //                 }, 2000)
            //             }
            //         } else if (handlerState === "yes_state") {
            //             try {
            //                 const { result, error } = await getHandler(message.toUpperCase(), "");
            //                 if (error) {
            //                     throw error
            //                 }
            //                 if (result?.error) {
            //                     throw result.error
            //                 }
            //                 dispatch(handleAnswerCalling(false));
            //             } catch (error: any) {
            //                 if (error === "handler_name already exists") {
            //                     handleAnswerResponse(uniqueId, message, `Welcome back **${message.toUpperCase()}**!`);
            //                     Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, message.toUpperCase(), { expires: 1000 });
            //                     dispatch(controlHandlerState(""));
            //                     dispatch(handleAnswerCalling(false));
            //                 } else if (error === "handler_name does not exists") {
            //                     const attempts = localStorage.getItem("attempt");
            //                     if (attempts === null) {
            //                         localStorage.setItem("attempt", '1')
            //                         handleAnswerResponse(uniqueId, message, `The handle **${message.toUpperCase()}** does not exist. Please enter a valid handle. You have only 1 attempt remaining.`);
            //                     } else if (attempts === '1') {
            //                         handleAnswerResponse(uniqueId, message, `The handle **${message.toUpperCase()}** does not exist. You have entered an incorrect handle twice, exceeding the allowed limit.`);
            //                         const uniqueId2 = uuidv4();
            //                         setTimeout(() => {
            //                             dispatch(
            //                                 addQuestion({ id: uniqueId2, question: "", answer: "", isTyping: "Typing" })
            //                             );
            //                             firstTimeHandle(uniqueId2, "", "To ensure a seamless experience, we have now assigned you a new handle:");
            //                             localStorage.removeItem("attempt");
            //                         }, 2000)
            //                     }
            //                 } else {
            //                     toast.error(error, {
            //                         style: {
            //                             backgroundColor: '#F1F1F1', // Grey background
            //                         }
            //                     })
            //                 }
            //             }
            //         } else if (handlerState === "no_state") {
            //             // if (myconst.noSynonyms.some((i: string) => message.toLowerCase().includes(i))) {
            //             if (myconst.noSynonyms.includes(message.toLowerCase())) {
            //                 handleAnswerResponse(uniqueId, message, `Welcome to ShopMate **${userHandlerName}**.`);
            //                 Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
            //                 dispatch(controlHandlerState(""));
            //                 // } else if (myconst.yesSynonyms.some((i: string) => message.toLowerCase().includes(i))) {
            //             } else if (myconst.yesSynonyms.includes(message.toLowerCase())) {
            //                 handleAnswerResponse(uniqueId, message, `Please enter the handle of your choice. You have 2 attempts to enter a valid choice. Handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles shorter than 8 digits and longer than 10 digits are not allowed.`);
            //             } else {
            //                 if (/^[a-zA-Z0-9]{8,10}$/.test(message)) {
            //                     try {
            //                         const { result, error } = await getHandler(message.toUpperCase(), userHandlerName);
            //                         if (error) {
            //                             throw error
            //                         }
            //                         if (result?.error) {
            //                             throw result.error
            //                         }
            //                         await handleAnswerResponse(uniqueId, message, `Your handle has been successfully updated from **${userHandlerName}** to **${result.handler_name}**.`);
            //                         const uniqueId2 = uuidv4();
            //                         await handleAnswerResponseAdd(uniqueId2, "", `Welcome to ShopMate **${result.handler_name}**.`);
            //                         dispatch(controlHandlerState(""));
            //                         Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, result.handler_name, { expires: 1000 });
            //                     } catch (error: any) {
            //                         if (error === "handler_name already exists") {
            //                             const handler_name_exist = localStorage.getItem("handler_name_exist");
            //                             if (handler_name_exist === null) {
            //                                 localStorage.setItem('handler_name_exist', '1')
            //                                 handleAnswerResponse(uniqueId, message, `This handle already exists. Please try a different one. You have only 1 attempt remaining.`);
            //                             } else if (handler_name_exist === '1') {
            //                                 localStorage.removeItem('handler_name_exist');
            //                                 await handleAnswerResponse(uniqueId, message, `This handle already exists.`);
            //                                 const uniqueId2 = uuidv4();
            //                                 await handleAnswerResponseAdd(uniqueId2, "", `You have added existed handle twice. To ensure a seamless exeperiance, we have assigned you the handle: **${userHandlerName}**.`);
            //                                 Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
            //                                 dispatch(controlHandlerState(""));
            //                             }
            //                         } else {
            //                             toast.error(error, {
            //                                 style: {
            //                                     backgroundColor: '#F1F1F1', // Grey background
            //                                 }
            //                             })
            //                         }
            //                     }
            //                 } else {
            //                     const false_attempt = localStorage.getItem("false_attempt")
            //                     if (false_attempt === null) {
            //                         localStorage.setItem("false_attempt", '1')
            //                         handleAnswerResponse(uniqueId, message, `The handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles outside this range are not allowed. You have only 1 attempt remaining.`);
            //                     } else if (false_attempt === '1') {
            //                         localStorage.removeItem("false_attempt");
            //                         await handleAnswerResponse(uniqueId, message, `Handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles outside this range are not allowed.`);
            //                         const uniqueId2 = uuidv4();
            //                         await handleAnswerResponseAdd(uniqueId2, "", `You have entered an invalid pattern twice. To ensure a seamless exeperiance, we have assigned you the handle: **${userHandlerName}**.`);
            //                         Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
            //                         dispatch(controlHandlerState(""));
            //                     }
            //                 }
            //             }
            //         }

            //     }
            // } else {
            dispatch(controlHandlerState(""));
            if (Object.keys(addToCartObj).length !== 0) {
                if (myconst.yesSynonyms.some((i: string) => message.toLowerCase().includes(i))) {
                    try {
                        const body = {
                            client_env: localStorage.getItem("clientName"),
                            handler_name: userHandler,
                            product_id: `${addToCartObj.code}`,
                            conversation_id: botId
                        }
                        const { result, error } = await user_story_bundling_api(body);
                        dispatch(addOrRemoveObjectForAddToCart({}));
                        if (error) {
                            throw error
                        }
                        if (result?.error) {
                            throw result.error
                        }
                        if (result?.results === "something went wrong") {
                            throw result.results
                        }
                        dispatch(
                            updateQuestion({
                                id: uniqueId,
                                question: message,
                                answer: `Great! Here are some products related to your preference for ${addToCartObj.name}.`,
                                isTyping: "Done",
                                is_file: false,
                                productType: "product_recommendation",
                                products: result?.results,
                            })
                        );
                        handleSpeak(`Great! Here are some products related to your preference for ${addToCartObj.name}.`, uniqueId)
                        dispatch(handleAnswerCalling(false));
                    } catch (error: any) {
                        dispatch(setSuggestionList([]));
                        // toast.error(error, {
                        //     style: {
                        //         backgroundColor: '#F1F1F1', // Grey background
                        //     }
                        // })
                        dispatch(
                            updateQuestion({
                                id: uniqueId,
                                question: message,
                                answer: error,
                                isTyping: "Done",
                                is_file: false,
                                productType: "product_search",
                                // products: result?.results,
                            })
                        );
                        dispatch(handleAnswerCalling(false));
                        handleSpeak(error, uniqueId)
                    }
                } else {
                    dispatch(addOrRemoveObjectForAddToCart({}));
                    handleAnswerResponse(uniqueId, message, `Awesome! If you need any more help or have questions about anything else, feel free to ask.`);
                    // dispatch(
                    //     updateQuestion({
                    //         id: uniqueId,
                    //         question: message,
                    //         answer: "Awesome! If you need any more help or have questions about anything else, feel free to ask.",
                    //         isTyping: "Done",
                    //         is_file: "",
                    //         productType: "product_search"
                    //     })
                    // );
                }
            } else {
                if (productList?.length > 0 || productCartList?.length > 0) {
                    const uniqueId = uuidv4();
                    dispatch(
                        addQuestion({ id: uniqueId, question: message, answer: "", isTyping: "Typing" })
                    );
                    try {
                        const { result, error } = await getAnswerTest(
                            encodeURIComponent(message),
                            Client,
                            botId ? botId : "",
                            chatToken?.length !== 0 ? localStorage.getItem("chatUserName") : "",
                            // userHandler,
                            true,
                            singleProduct
                        );
                        if (error) {
                            throw error
                        }
                        if (result?.error) {
                            throw result.error
                        }
                        // Handle PER_INFO response
                        if (result?.answer === "PER_INFO") {
                            dispatch(handleBotLoginQue(message))
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: message,
                                    answer: "Please provide me your Email Id!",
                                    isTyping: "Done",
                                    productType: "product_search"
                                })
                            );
                            handleSpeak("Please provide me your Email Id!", uniqueId)
                            dispatch(setSuggestionList([]));
                            setError(true);
                            dispatch(handleAnswerCalling(false));
                        } else if (result?.is_recommend) {
                            // Handle different response types
                            // Product recommendation response
                            const answerText = result?.message || "Certainly! Here are some suggestions:";
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: message,
                                    answer: answerText,
                                    isTyping: "Done",
                                    is_file: false,
                                    productType: "product_recommendation",
                                    products: result.answer,
                                })
                            );
                            if (answerText) {
                                handleSpeak(answerText, uniqueId);
                            }
                            if (result?.suggested_questions) {
                                dispatch(setSuggestionList(result.suggested_questions));
                            }
                        } else if (result?.is_cart) {
                            dispatch(setSuggestionList(result.suggested_questions))
                            // Assuming cartProducts is an array of objects with a unique 'id'
                            const newProducts = result.answer.products_added;
                            const sameProducts = newProducts.filter(
                                (newProd: any) => cartProducts.some((existingProd: any) => existingProd.code === newProd.code)
                            );
                            const diffProducts = newProducts.filter(
                                (newProd: any) => cartProducts.every((existingProd: any) => existingProd.code !== newProd.code)
                            );
                            if (sameProducts.length > 0) {
                                const manyReturn = (many: string, much: string, products: any) => {
                                    if (products.length > 1) {
                                        return many
                                    } else {
                                        return much
                                    }
                                }
                                const getQuantityText = (products: any[]) => {
                                    if (products.length === 1 && products[0].quantity && products[0].quantity !== 0 && products[0].quantity !== "" && products[0].quantity !== null && products[0].quantity !== undefined) {
                                        return ` along with **${products[0].quantity}** more quantity`;
                                    }
                                    return "";
                                }
                                const quantityText = getQuantityText(sameProducts);
                                if (diffProducts.length === 0) {
                                    dispatch(
                                        updateQuestion({
                                            id: uniqueId,
                                            question: message,
                                            answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`,
                                            isTyping: "Done",
                                            is_file: result.is_file,
                                            productType: "product_search"
                                        })
                                    );
                                    handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`, uniqueId)
                                    // Merge products: add quantities for existing products
                                    const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                    setCartsProduct(mergedProducts);
                                    localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                                } else {
                                    dispatch(
                                        updateQuestion({
                                            id: uniqueId,
                                            question: message,
                                            answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`,
                                            isTyping: "Done",
                                            is_file: result.is_file,
                                            productType: "product_search"
                                        })
                                    );
                                    handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`, uniqueId)
                                    // Merge products: add quantities for existing products, add new products
                                    const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                    setCartsProduct(mergedProducts);
                                    localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                                }
                                dispatch(handleAnswerCalling(false));
                            } else {
                                dispatch(setSuggestionList(result.suggested_questions))
                                dispatch(
                                    updateQuestion({
                                        id: uniqueId,
                                        question: message,
                                        answer: result.message,
                                        isTyping: "Done",
                                        is_file: result.is_file,
                                        productType: "product_search"
                                    })
                                );
                                handleSpeak(result?.message, uniqueId)
                                // Merge products: add quantities for existing products, add new products
                                const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                setCartsProduct(mergedProducts);
                                localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                                dispatch(handleAnswerCalling(false));
                            }
                        } else {
                            // Regular response
                            const answerText = result?.response || result?.answer || result?.message || "";
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: message,
                                    answer: answerText,
                                    isTyping: "Done",
                                    is_file: false,
                                    productType: "product_search",
                                })
                            );
                            if (answerText) {
                                handleSpeak(answerText, uniqueId);
                            }
                            if (result?.suggested_questions) {
                                dispatch(setSuggestionList(result.suggested_questions));
                            }
                        }

                        // Handle pdp_flag from response after updating question
                        if (result?.pdp_flag !== undefined) {
                            // Capture current state before async operation
                            const currentProductCartListLength = productCartList.length;
                            const isPdpOpen = productList?.length > 0 || productCartList?.length > 0;

                            if (result.pdp_flag === false && isPdpOpen) {
                                // Close PDP page if pdp_flag is false and page is open
                                // Use setTimeout to ensure question is rendered first
                                setTimeout(() => {
                                    if (currentProductCartListLength === 0) {
                                        setProductList([]);
                                        setProductCompareList([]);
                                        setActiveIndexBundleProduct(0);
                                        setActiveIndexStyledProduct(0);
                                        scrollToBottom();
                                        setAddToCartBtnName("Add to Cart");
                                        dispatch(resetProductPageQuestion());
                                    } else {
                                        dispatch(resetProductPageQuestion());
                                        setCartPageVisible(true);
                                        setProductCartList([]);
                                    }
                                }, 100);
                            }
                            // If pdp_flag is true, keep PDP page open as it is (no action needed)
                        }
                        dispatch(handleAnswerCalling(false));

                    } catch (error: any) {
                        dispatch(
                            updateQuestion({
                                id: uniqueId,
                                question: message,
                                answer: error,
                                isTyping: "Done",
                                productType: "product_search",
                            })
                        );
                        handleSpeak(error, uniqueId)
                        dispatch(handleAnswerCalling(false));
                        return {};
                    }
                } else {
                    if (errored) {
                        const u_name: string = message.trim();
                        // const user_name_attempts = localStorage.getItem("user_name_attempts");
                        // const password_attempts = localStorage.getItem("user_name_attempts");
                        if (message && test !== "Please provide your password." && chatToken?.length === 0) {
                            try {
                                const { result, error } = await getVerifiedEmail(u_name)
                                setSendOtp(result.message)
                                if (error) {
                                    throw error
                                }
                                if (result.message === "user verified successfully") {
                                    setTest("Please provide your password.")
                                    localStorage.setItem("chatUserName", u_name);
                                    setChatName(u_name);
                                    setTypePassword(true);
                                    dispatch(
                                        addQuestion({ id: uniqueId, question: message, answer: "", isTyping: "Typing" })
                                    );
                                    handleAnswerResponse(uniqueId, message, "Please provide your password.")
                                } else if (result.error === "user not found") {
                                    // } else if (result.error === "user not found" && user_name_attempts === null) {
                                    localStorage.setItem("user_name_attempts", '1');
                                    setTest("Kindly provide the correct email ID to submit your questions.")
                                    dispatch(
                                        addQuestion({ id: uniqueId, question: message, answer: "", isTyping: "Typing" })
                                    );
                                    handleAnswerResponse(uniqueId, message, "Kindly provide the correct email ID to submit your questions.")
                                }
                                // else if (result.error === "user not found" && user_name_attempts === "1") {
                                //     localStorage.removeItem("user_name_attempts")
                                //     dispatch(
                                //         addQuestion({ id: uniqueId, question: message, answer: "", isTyping: "Typing" })
                                //     );
                                //     handleAnswerResponse(uniqueId, message, "Kindly provide the correct email ID to submit your questions.")
                                // }
                            } catch (error) {
                            }
                        }
                        if (message && test === "Please provide your password." && chatToken?.length === 0) {
                            try {
                                const { result, error } = await login(localStorage.getItem("chatUserName"), encryptPassword(message));
                                if (error) {
                                    throw error
                                }
                                if (result?.error) {
                                    // if (password_attempts === null) {
                                    const temp = replaceAllWithAsterisks(message)
                                    dispatch(
                                        addQuestion({ id: uniqueId, question: temp, answer: "", isTyping: "Typing" })
                                    );
                                    handleAnswerResponse(uniqueId, replaceAllWithAsterisks(message), "It appears that your password is incorrect. please try again!")
                                    // } else if (password_attempts === "1") {
                                    //     localStorage.removeItem("password_attempts")
                                    //     dispatch(
                                    //         addQuestion({ id: uniqueId, question: replaceAllWithAsterisks(message), answer: "", isTyping: "Typing" })
                                    //     );
                                    //     handleAnswerResponse(uniqueId, replaceAllWithAsterisks(message), "It appears that your password is incorrect. please try again!")
                                    // }
                                } else {
                                    localStorage.setItem("chat_access_token", result?.auth_info?.access_token)
                                    setChatToken(result?.auth_info.access_token)
                                    setTest("")
                                    dispatch(
                                        addQuestion({ id: uniqueId, question: replaceAllWithAsterisks(message), answer: "", isTyping: "Typing" })
                                    );
                                    setError(false);
                                    try {
                                        const { result, error } = await getAnswerTest(encodeURIComponent(botLoginQue), Client, botId ? botId : "", localStorage.getItem("chatUserName"), 
                                        // userHandler, 
                                        false);
                                        if (error) {
                                            throw error
                                        }
                                        if (result?.error) {
                                            throw result.error
                                        }
                                        setTypePassword(false)
                                        localStorage.setItem('lastBotQuestion', String(Date.now()));
                                        // setOutputMessage(response);
                                        localStorage.setItem("botId", result.conversation_id)
                                        handleAnswerResponse(uniqueId, replaceAllWithAsterisks(message), `Thank you for logging in.\n${result.answer}`)
                                        dispatch(setSuggestionList(result.suggested_questions))
                                        // setTimeout(() => {
                                        //     handleAnswerResponse("", message, result.answer)
                                        // }, 1000)
                                    } catch (error: any) {
                                        dispatch(
                                            updateQuestion({
                                                id: uniqueId,
                                                question: replaceAllWithAsterisks(message),
                                                answer: error,
                                                isTyping: "Done",
                                                productType: "product_search",
                                            })
                                        );
                                        handleSpeak(error, uniqueId)
                                        setTypePassword(false)
                                        dispatch(handleAnswerCalling(false));
                                        return {};
                                    }
                                }
                            } catch (error: any) {
                                dispatch(
                                    updateQuestion({
                                        id: uniqueId,
                                        question: message,
                                        answer: error,
                                        isTyping: "Done",
                                        productType: "product_search",
                                    })
                                );
                                handleSpeak(error, uniqueId)
                                dispatch(handleAnswerCalling(false));
                                return {};
                            }
                        }
                    }
                    else {
                        try {
                            const { result, error } = await getAnswerTest(encodeURIComponent(message), Client, botId ? botId : "", chatToken?.length !== 0 ? localStorage.getItem("chatUserName") : "", 
                            // userHandler, 
                            false);
                            // const { result, error } = await getAnswer(encodeURIComponent(message), Client, botId ? botId : "", chatToken.length !== 0 ? localStorage.getItem("chatUserName") : "");
                            if (error) {
                                throw error
                            }
                            if (result?.error) {
                                throw result.error
                            }
                            localStorage.setItem('lastBotQuestion', String(Date.now()));
                            localStorage.setItem("botId", result.conversation_id)
                            if (result?.answer === "PER_INFO") {
                                dispatch(handleBotLoginQue(message))
                                dispatch(
                                    updateQuestion({
                                        id: uniqueId,
                                        question: message,
                                        answer: "Please provide me your Email Id!",
                                        isTyping: "Done",
                                        productType: "product_search"
                                    })
                                );
                                handleSpeak("Please provide me your Email Id!", uniqueId)
                                dispatch(setSuggestionList([]));
                                setError(true);
                                dispatch(handleAnswerCalling(false));
                            } else {
                                if (result?.is_recommend) {
                                    if (result?.message !== null && result?.message !== "") {
                                        dispatch(
                                            updateQuestion({
                                                id: uniqueId,
                                                question: message,
                                                answer: result?.message,
                                                isTyping: "Done",
                                                is_file: false,
                                                productType: "product_recommendation",
                                                products: result.answer,
                                            })
                                        );
                                        handleSpeak(result?.message, uniqueId)
                                        dispatch(setSuggestionList(result.suggested_questions))
                                        dispatch(handleAnswerCalling(false));
                                    } else {
                                        dispatch(
                                            updateQuestion({
                                                id: uniqueId,
                                                question: message,
                                                answer: "Certainly! Here are some suggestions:",
                                                isTyping: "Done",
                                                is_file: false,
                                                productType: "product_recommendation",
                                                products: result.answer,
                                            })
                                        );
                                        handleSpeak("Certainly! Here are some suggestions:", uniqueId)
                                        dispatch(setSuggestionList(result.suggested_questions))
                                        dispatch(handleAnswerCalling(false));
                                    }
                                } else if (result?.is_cart) {
                                    dispatch(setSuggestionList(result.suggested_questions))
                                    // Assuming cartProducts is an array of objects with a unique 'id'
                                    const newProducts = result.answer.products_added;
                                    const sameProducts = newProducts.filter(
                                        (newProd: any) => cartProducts.some((existingProd: any) => existingProd.code === newProd.code)
                                    );
                                    const diffProducts = newProducts.filter(
                                        (newProd: any) => cartProducts.every((existingProd: any) => existingProd.code !== newProd.code)
                                    );
                                    if (sameProducts.length > 0) {
                                        const manyReturn = (many: string, much: string, products: any) => {
                                            if (products.length > 1) {
                                                return many
                                            } else {
                                                return much
                                            }
                                        }
                                        const getQuantityText = (products: any[]) => {
                                            if (products.length === 1 && products[0].quantity && products[0].quantity !== 0 && products[0].quantity !== "" && products[0].quantity !== null && products[0].quantity !== undefined) {
                                                return ` along with **${products[0].quantity}** more quantity`;
                                            }
                                            return "";
                                        }
                                        const quantityText = getQuantityText(sameProducts);
                                        if (diffProducts.length === 0) {
                                            dispatch(
                                                updateQuestion({
                                                    id: uniqueId,
                                                    question: message,
                                                    answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`,
                                                    isTyping: "Done",
                                                    is_file: result.is_file,
                                                    productType: "product_search"
                                                })
                                            );
                                            handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`, uniqueId)
                                            // Merge products: add quantities for existing products
                                            const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                            setCartsProduct(mergedProducts);
                                            localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                                        } else {
                                            dispatch(
                                                updateQuestion({
                                                    id: uniqueId,
                                                    question: message,
                                                    answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`,
                                                    isTyping: "Done",
                                                    is_file: result.is_file,
                                                    productType: "product_search"
                                                })
                                            );
                                            handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`, uniqueId)
                                            // Merge products: add quantities for existing products, add new products
                                            const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                            setCartsProduct(mergedProducts);
                                            localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                                        }
                                        dispatch(handleAnswerCalling(false));
                                    } else {
                                        dispatch(setSuggestionList(result.suggested_questions))
                                        dispatch(
                                            updateQuestion({
                                                id: uniqueId,
                                                question: message,
                                                answer: result.message,
                                                isTyping: "Done",
                                                is_file: result.is_file,
                                                productType: "product_search"
                                            })
                                        );
                                        handleSpeak(result?.message, uniqueId)
                                        // Merge products: add quantities for existing products, add new products
                                        const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                        setCartsProduct(mergedProducts);
                                        localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                                        dispatch(handleAnswerCalling(false));
                                    }
                                } else {
                                    if (localStorage.getItem("clientName") !== "InzaloEMS") {
                                        dispatch(setSuggestionList(result.suggested_questions))
                                        dispatch(
                                            updateQuestion({
                                                id: uniqueId,
                                                question: message,
                                                answer: result.answer,
                                                isTyping: "Done",
                                                is_file: result.is_file,
                                                productType: "product_search"
                                            })
                                        );
                                        handleSpeak(result.answer, uniqueId)
                                        dispatch(handleAnswerCalling(false));
                                    } else {
                                        dispatch(
                                            updateQuestion({
                                                id: uniqueId,
                                                question: message,
                                                answer: result.answer,
                                                isTyping: "Done",
                                                is_file: result.is_file,
                                                productType: "product_search"
                                            })
                                        );
                                        handleSpeak(result.answer, uniqueId)
                                        dispatch(handleAnswerCalling(false));

                                    }
                                }
                            }

                        } catch (error: any) {
                            dispatch(setSuggestionList([]));
                            if (error === "Need to login") {
                                dispatch(handleBotLoginQue(message))
                                dispatch(
                                    updateQuestion({
                                        id: uniqueId,
                                        question: message,
                                        answer: "Please provide me your Email Id!",
                                        isTyping: "Done",
                                        productType: "product_search"
                                    })
                                );
                                handleSpeak("Please provide me your Email Id!", uniqueId)
                                dispatch(handleAnswerCalling(false));
                                setError(true);
                            } else {
                                // Handle other errors
                                dispatch(
                                    updateQuestion({
                                        id: uniqueId,
                                        question: message,
                                        answer: error,
                                        isTyping: "Done",
                                        productType: "product_search"
                                    })
                                );
                                handleSpeak(error, uniqueId)
                                dispatch(handleAnswerCalling(false));
                            }
                            return {};
                        }
                    }
                }
            }
            // }

        }

    }
    const handleClickMessageSuggestion = async (suggestion: string) => {
        // Stop any currently playing audio
        if (currentAudioRef.current) {
            currentAudioRef.current.pause();
            currentAudioRef.current = null;
            dispatch(setStopId(''));
        }
        dispatch(handleAnswerCalling(true));
        setMessage("");
        const uniqueId = uuidv4();
        if (!errored && productList?.length === 0 && productCartList?.length === 0) {
            dispatch(
                addQuestion({ id: uniqueId, question: suggestion, answer: "", isTyping: "Typing" })
            );
        }
        let Client: string | null = "";
        const env = localStorage.getItem("clientName")
        if (window.location.origin === 'https://ron.rysun.in:3001' && env === "ron_prod") {
            Client = "frida_prod"
        } else if (window.location.origin !== 'https://ron.rysun.in:3001' && (env === "ron_stage" || env === "ron_dev")) {
            Client = "frida"
        } else {
            if (localStorage.getItem("envParam") === "Firstwatch") {
                Client = "Firstwatch"
            } else {
                Client = env
            }
        }
        let botId = localStorage.getItem("botId") || "";
        // if (userHandler === undefined) {
        //     if (localStorage.getItem('username') === undefined || localStorage.getItem('username') === null) {
        //         // localStorage.clear()
        //         localStorage.removeItem('access_token');
        //         localStorage.removeItem('announcements');
        //         //localStorage.removeItem('clientName');
        //         localStorage.removeItem('default_label');
        //         localStorage.removeItem('default_questions');
        //         localStorage.removeItem('feature-flag');
        //         localStorage.removeItem('firstName');
        //         localStorage.removeItem('isLogged');
        //         localStorage.removeItem('lastActivity');
        //         localStorage.removeItem('lastName');
        //         localStorage.removeItem('loginTime');
        //         localStorage.removeItem('logos');
        //         localStorage.removeItem('permissions');
        //         localStorage.removeItem('refresh_token');
        //         localStorage.removeItem('username');
        //         localStorage.removeItem('lastBotQuestion');
        //         localStorage.removeItem('botId');
        //         localStorage.removeItem("wrongAttempt");
        //         localStorage.removeItem("attempt");
        //         localStorage.removeItem('handler_name_exist');
        //         localStorage.removeItem("false_attempt");
        //         localStorage.removeItem("user_name_attempts")
        //         localStorage.removeItem("chatUserName");
        //         localStorage.removeItem("chat_access_token");
        //         window.location.href = '/login'
        //     }
        //     dispatch(setIsNewConversation("old"));
        //     // if (myconst.noSynonyms.some((i: string) => message.toLowerCase().includes(i)) && handlerState === "") {
        //     if (myconst.noSynonyms.includes(suggestion.toLowerCase()) && handlerState === "") {
        //         firstTimeHandle(uniqueId, suggestion, "To personalize your chat experience, we have assigned you a handle:");
        //         // } else if (myconst.yesSynonyms.some((i: string) => message.toLowerCase().includes(i)) && handlerState === "") {
        //     } else if (myconst.yesSynonyms.includes(suggestion.toLowerCase()) && handlerState === "") {
        //         handleAnswerResponse(uniqueId, suggestion, `Please provide your handle. You have 2 attempts to enter a valid handle.`);
        //         dispatch(controlHandlerState("yes_state"));
        //         dispatch(handleAnswerCalling(false));
        //         // handleAnswerResponse(uniqueId, message, "Kindly provide the correct display name to submit your questions.")
        //     } else {
        //         if (handlerState === "") {
        //             const wrongAttempt = localStorage.getItem("wrongAttempt");
        //             if (wrongAttempt === null) {
        //                 localStorage.setItem("wrongAttempt", '1')
        //                 handleAnswerResponse(uniqueId, suggestion, `Please provide a valid response. You have only 1 attempt remaining.`);
        //                 dispatch(handleAnswerCalling(false));
        //             } else if (wrongAttempt === '1') {
        //                 handleAnswerResponse(uniqueId, suggestion, `You have entered an incorrect response twice, exceeding the allowed limit.`);
        //                 const uniqueId2 = uuidv4();
        //                 setTimeout(() => {
        //                     dispatch(
        //                         addQuestion({ id: uniqueId2, question: "", answer: "", isTyping: "Typing" })
        //                     );
        //                     firstTimeHandle(uniqueId2, "", "To ensure a seamless experience, we have now assigned you a new handle:");
        //                     localStorage.removeItem("wrongAttempt");
        //                 }, 2000)
        //             }
        //         } else if (handlerState === "yes_state") {
        //             try {
        //                 const { result, error } = await getHandler(suggestion.toUpperCase(), "");
        //                 if (error) {
        //                     throw error
        //                 }
        //                 if (result?.error) {
        //                     throw result.error
        //                 }
        //                 dispatch(handleAnswerCalling(false));
        //             } catch (error: any) {
        //                 if (error === "handler_name already exists") {
        //                     handleAnswerResponse(uniqueId, suggestion, `Welcome back **${suggestion.toUpperCase()}**!`);
        //                     Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, suggestion.toUpperCase(), { expires: 1000 });
        //                     dispatch(controlHandlerState(""));
        //                     dispatch(handleAnswerCalling(false));
        //                 } else if (error === "handler_name does not exists") {
        //                     const attempts = localStorage.getItem("attempt");
        //                     if (attempts === null) {
        //                         localStorage.setItem("attempt", '1')
        //                         handleAnswerResponse(uniqueId, suggestion, `The handle **${suggestion.toUpperCase()}** does not exist. Please enter a valid handle. You have only 1 attempt remaining.`);
        //                     } else if (attempts === '1') {
        //                         handleAnswerResponse(uniqueId, suggestion, `The handle **${suggestion.toUpperCase()}** does not exist. You have entered an incorrect handle twice, exceeding the allowed limit.`);
        //                         const uniqueId2 = uuidv4();
        //                         setTimeout(() => {
        //                             dispatch(
        //                                 addQuestion({ id: uniqueId2, question: "", answer: "", isTyping: "Typing" })
        //                             );
        //                             firstTimeHandle(uniqueId2, "", "To ensure a seamless experience, we have now assigned you a new handle:");
        //                             localStorage.removeItem("attempt");
        //                         }, 2000)
        //                     }
        //                 } else {
        //                     toast.error(error, {
        //                         style: {
        //                             backgroundColor: '#F1F1F1', // Grey background
        //                         }
        //                     })
        //                 }
        //             }
        //         } else if (handlerState === "no_state") {
        //             // if (myconst.noSynonyms.some((i: string) => message.toLowerCase().includes(i))) {
        //             if (myconst.noSynonyms.includes(suggestion.toLowerCase())) {
        //                 handleAnswerResponse(uniqueId, suggestion, `Welcome to ShopMate **${userHandlerName}**.`);
        //                 Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
        //                 dispatch(controlHandlerState(""));
        //                 // } else if (myconst.yesSynonyms.some((i: string) => suggestion.toLowerCase().includes(i))) {
        //             } else if (myconst.yesSynonyms.includes(suggestion.toLowerCase())) {
        //                 handleAnswerResponse(uniqueId, suggestion, `Please enter the handle of your choice. You have 2 attempts to enter a valid choice. Handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles shorter than 8 digits and longer than 10 digits are not allowed.`);
        //             } else {
        //                 if (/^[a-zA-Z0-9]{8,10}$/.test(suggestion)) {
        //                     try {
        //                         const { result, error } = await getHandler(suggestion.toUpperCase(), userHandlerName);
        //                         if (error) {
        //                             throw error
        //                         }
        //                         if (result?.error) {
        //                             throw result.error
        //                         }
        //                         await handleAnswerResponse(uniqueId, suggestion, `Your handle has been successfully updated from **${userHandlerName}** to **${result.handler_name}**.`);
        //                         const uniqueId2 = uuidv4();
        //                         await handleAnswerResponseAdd(uniqueId2, "", `Welcome to ShopMate **${result.handler_name}**.`);
        //                         dispatch(controlHandlerState(""));
        //                         Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, result.handler_name, { expires: 1000 });
        //                     } catch (error: any) {
        //                         if (error === "handler_name already exists") {
        //                             const handler_name_exist = localStorage.getItem("handler_name_exist");
        //                             if (handler_name_exist === null) {
        //                                 localStorage.setItem('handler_name_exist', '1')
        //                                 handleAnswerResponse(uniqueId, suggestion, `This handle already exists. Please try a different one. You have only 1 attempt remaining.`);
        //                             } else if (handler_name_exist === '1') {
        //                                 localStorage.removeItem('handler_name_exist');
        //                                 await handleAnswerResponse(uniqueId, suggestion, `This handle already exists.`);
        //                                 const uniqueId2 = uuidv4();
        //                                 await handleAnswerResponseAdd(uniqueId2, "", `You have added existed handle twice. To ensure a seamless exeperiance, we have assigned you the handle: **${userHandlerName}**.`);
        //                                 Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
        //                                 dispatch(controlHandlerState(""));
        //                             }
        //                         } else {
        //                             toast.error(error, {
        //                                 style: {
        //                                     backgroundColor: '#F1F1F1', // Grey background
        //                                 }
        //                             })
        //                         }
        //                     }
        //                 } else {
        //                     const false_attempt = localStorage.getItem("false_attempt")
        //                     if (false_attempt === null) {
        //                         localStorage.setItem("false_attempt", '1')
        //                         handleAnswerResponse(uniqueId, suggestion, `The handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles outside this range are not allowed. You have only 1 attempt remaining.`);
        //                     } else if (false_attempt === '1') {
        //                         localStorage.removeItem("false_attempt");
        //                         await handleAnswerResponse(uniqueId, suggestion, `Handle must be alphanumeric and between 8 to 10 characters long. Special characters and handles outside this range are not allowed.`);
        //                         const uniqueId2 = uuidv4();
        //                         await handleAnswerResponseAdd(uniqueId2, "", `You have entered an invalid pattern twice. To ensure a seamless exeperiance, we have assigned you the handle: **${userHandlerName}**.`);
        //                         Cookies.set(`handler_${encodeURI(localStorage.getItem('username') as any)}`, userHandlerName, { expires: 1000 });
        //                         dispatch(controlHandlerState(""));
        //                     }
        //                 }
        //             }
        //         }

        //     }
        // } else {
        dispatch(controlHandlerState(""));
        if (Object.keys(addToCartObj).length !== 0) {
            if (myconst.yesSynonyms.some((i: string) => suggestion.toLowerCase().includes(i))) {
                try {
                    const body = {
                        client_env: localStorage.getItem("clientName"),
                        handler_name: userHandler,
                        product_id: `${addToCartObj.code}`,
                        conversation_id: botId
                    }
                    const { result, error } = await user_story_bundling_api(body);
                    dispatch(addOrRemoveObjectForAddToCart({}));
                    if (error) {
                        throw error
                    }
                    if (result?.error) {
                        throw result.error
                    }
                    if (result?.results === "something went wrong") {
                        throw result.results
                    }
                    dispatch(
                        updateQuestion({
                            id: uniqueId,
                            question: suggestion,
                            answer: `Great! Here are some products related to your preference for ${addToCartObj.name}.`,
                            isTyping: "Done",
                            is_file: false,
                            productType: "product_recommendation",
                            products: result?.results,
                        })
                    );
                    handleSpeak(`Great! Here are some products related to your preference for ${addToCartObj.name}.`, uniqueId)
                    dispatch(handleAnswerCalling(false));
                } catch (error: any) {
                    // toast.error(error, {
                    //     style: {
                    //         backgroundColor: '#F1F1F1', // Grey background
                    //     }
                    // })
                    dispatch(
                        updateQuestion({
                            id: uniqueId,
                            question: suggestion,
                            answer: error,
                            isTyping: "Done",
                            is_file: false,
                            productType: "product_search",
                            // products: result?.results,
                        })
                    );
                    handleSpeak(error, uniqueId)
                    dispatch(handleAnswerCalling(false));
                }
            } else {
                dispatch(addOrRemoveObjectForAddToCart({}));
                handleAnswerResponse(uniqueId, suggestion, `Awesome! If you need any more help or have questions about anything else, feel free to ask.`);
                // dispatch(
                //     updateQuestion({
                //         id: uniqueId,
                //         question: message,
                //         answer: "Awesome! If you need any more help or have questions about anything else, feel free to ask.",
                //         isTyping: "Done",
                //         is_file: "",
                //         productType: "product_search"
                //     })
                // );
            }
        } else {
            if (productList?.length > 0 || productCartList?.length > 0) {
                const uniqueId = uuidv4();
                dispatch(
                    addQuestion({ id: uniqueId, question: suggestion, answer: "", isTyping: "Typing" })
                );
                try {
                    const { result, error } = await getAnswerTest(
                        encodeURIComponent(suggestion),
                        Client,
                        botId ? botId : "",
                        chatToken?.length !== 0 ? localStorage.getItem("chatUserName") : "",
                        // userHandler,
                        true,
                        singleProduct
                    );
                    if (error) {
                        throw error
                    }
                    if (result?.error) {
                        throw result.error
                    }
                    // Handle PER_INFO response
                    if (result?.answer === "PER_INFO") {
                        dispatch(handleBotLoginQue(suggestion))
                        dispatch(
                            updateQuestion({
                                id: uniqueId,
                                question: suggestion,
                                answer: "Please provide me your Email Id!",
                                isTyping: "Done",
                                productType: "product_search"
                            })
                        );
                        handleSpeak("Please provide me your Email Id!", uniqueId)
                        dispatch(setSuggestionList([]));
                        setError(true);
                        dispatch(handleAnswerCalling(false));
                    } else if (result?.is_recommend) {
                        // Handle different response types
                        // Product recommendation response
                        const answerText = result?.message || "Certainly! Here are some suggestions:";
                        dispatch(
                            updateQuestion({
                                id: uniqueId,
                                question: suggestion,
                                answer: answerText,
                                isTyping: "Done",
                                is_file: false,
                                productType: "product_recommendation",
                                products: result.answer,
                            })
                        );
                        if (answerText) {
                            handleSpeak(answerText, uniqueId);
                        }
                        if (result?.suggested_questions) {
                            dispatch(setSuggestionList(result.suggested_questions));
                        }
                    } else if (result?.is_cart) {
                        dispatch(setSuggestionList(result.suggested_questions))
                        // Assuming cartProducts is an array of objects with a unique 'id'
                        const newProducts = result.answer.products_added;
                        const sameProducts = newProducts.filter(
                            (newProd: any) => cartProducts.some((existingProd: any) => existingProd.code === newProd.code)
                        );
                        const diffProducts = newProducts.filter(
                            (newProd: any) => cartProducts.every((existingProd: any) => existingProd.code !== newProd.code)
                        );
                        if (sameProducts.length > 0) {
                            const manyReturn = (many: string, much: string, products: any) => {
                                if (products.length > 1) {
                                    return many
                                } else {
                                    return much
                                }
                            }
                            const getQuantityText = (products: any[]) => {
                                if (products.length === 1 && products[0].quantity && products[0].quantity !== 0 && products[0].quantity !== "" && products[0].quantity !== null && products[0].quantity !== undefined) {
                                    return ` along with **${products[0].quantity}** more quantity`;
                                }
                                return "";
                            }
                            const quantityText = getQuantityText(sameProducts);
                            if (diffProducts.length === 0) {
                                dispatch(
                                    updateQuestion({
                                        id: uniqueId,
                                        question: suggestion,
                                        answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`,
                                        isTyping: "Done",
                                        is_file: result.is_file,
                                        productType: "product_search"
                                    })
                                );
                                handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`, uniqueId)
                                // Merge products: add quantities for existing products
                                const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                setCartsProduct(mergedProducts);
                                localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                            } else {
                                dispatch(
                                    updateQuestion({
                                        id: uniqueId,
                                        question: suggestion,
                                        answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`,
                                        isTyping: "Done",
                                        is_file: result.is_file,
                                        productType: "product_search"
                                    })
                                );
                                handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`, uniqueId)
                                // Merge products: add quantities for existing products, add new products
                                const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                setCartsProduct(mergedProducts);
                                localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                            }
                            dispatch(handleAnswerCalling(false));
                        } else {
                            dispatch(setSuggestionList(result.suggested_questions))
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: suggestion,
                                    answer: result.message,
                                    isTyping: "Done",
                                    is_file: result.is_file,
                                    productType: "product_search"
                                })
                            );
                            handleSpeak(result?.message, uniqueId)
                            // Merge products: add quantities for existing products, add new products
                            const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                            setCartsProduct(mergedProducts);
                            localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                            dispatch(handleAnswerCalling(false));
                        }
                    } else {
                        // Regular response
                        const answerText = result?.response || result?.answer || result?.message || "";
                        dispatch(
                            updateQuestion({
                                id: uniqueId,
                                question: suggestion,
                                answer: answerText,
                                isTyping: "Done",
                                is_file: false,
                                productType: "product_search",
                            })
                        );
                        if (answerText) {
                            handleSpeak(answerText, uniqueId);
                        }
                        if (result?.suggested_questions) {
                            dispatch(setSuggestionList(result.suggested_questions));
                        }
                    }

                    // Handle pdp_flag from response after updating question
                    if (result?.pdp_flag !== undefined) {
                        // Capture current state before async operation
                        const currentProductCartListLength = productCartList.length;
                        const isPdpOpen = productList?.length > 0 || productCartList?.length > 0;

                        if (result.pdp_flag === false && isPdpOpen) {
                            // Close PDP page if pdp_flag is false and page is open
                            // Use setTimeout to ensure question is rendered first
                            setTimeout(() => {
                                if (currentProductCartListLength === 0) {
                                    setProductList([]);
                                    setProductCompareList([]);
                                    setActiveIndexBundleProduct(0);
                                    setActiveIndexStyledProduct(0);
                                    scrollToBottom();
                                    setAddToCartBtnName("Add to Cart");
                                    dispatch(resetProductPageQuestion());
                                } else {
                                    dispatch(resetProductPageQuestion());
                                    setCartPageVisible(true);
                                    setProductCartList([]);
                                }
                            }, 100);
                        }
                        // If pdp_flag is true, keep PDP page open as it is (no action needed)
                    }
                    dispatch(handleAnswerCalling(false));

                } catch (error: any) {
                    dispatch(
                        updateQuestion({
                            id: uniqueId,
                            question: suggestion,
                            answer: error,
                            isTyping: "Done",
                            productType: "product_search",
                        })
                    );
                    handleSpeak(error, uniqueId)
                    dispatch(handleAnswerCalling(false));
                    return {};
                }
            } else {
                if (errored) {
                    const u_name: string = suggestion.trim();
                    // const user_name_attempts = localStorage.getItem("user_name_attempts");
                    // const password_attempts = localStorage.getItem("user_name_attempts");
                    if (suggestion && test !== "Please provide your password." && chatToken?.length === 0) {
                        try {
                            const { result, error } = await getVerifiedEmail(u_name)
                            setSendOtp(result.message)
                            if (error) {
                                throw error
                            }
                            if (result.message === "user verified successfully") {
                                setTest("Please provide your password.")
                                localStorage.setItem("chatUserName", u_name);
                                setChatName(u_name);
                                setTypePassword(true);
                                dispatch(
                                    addQuestion({ id: uniqueId, question: suggestion, answer: "", isTyping: "Typing" })
                                );
                                handleAnswerResponse(uniqueId, suggestion, "Please provide your password.")
                            } else if (result.error === "user not found") {
                                // } else if (result.error === "user not found" && user_name_attempts === null) {
                                localStorage.setItem("user_name_attempts", '1');
                                setTest("Kindly provide the correct email ID to submit your questions..")
                                dispatch(
                                    addQuestion({ id: uniqueId, question: suggestion, answer: "", isTyping: "Typing" })
                                );
                                handleAnswerResponse(uniqueId, suggestion, "Kindly provide the correct email ID to submit your questions.")
                            }
                            // else if (result.error === "user not found" && user_name_attempts === "1") {
                            //     localStorage.removeItem("user_name_attempts")
                            //     dispatch(
                            //         addQuestion({ id: uniqueId, question: suggestion, answer: "", isTyping: "Typing" })
                            //     );
                            //     handleAnswerResponse(uniqueId, suggestion, "Kindly provide the correct email ID to submit your questions.")
                            // }
                        } catch (error) {
                        }
                    }
                    if (suggestion && test === "Please provide your password." && chatToken?.length === 0) {
                        try {
                            const { result, error } = await login(localStorage.getItem("chatUserName"), encryptPassword(suggestion));
                            if (error) {
                                throw error
                            }
                            if (result?.error) {
                                // if (password_attempts === null) {
                                const temp = replaceAllWithAsterisks(suggestion)
                                dispatch(
                                    addQuestion({ id: uniqueId, question: temp, answer: "", isTyping: "Typing" })
                                );
                                handleAnswerResponse(uniqueId, replaceAllWithAsterisks(suggestion), "It appears that your password is incorrect. please try again!")
                                // } else if (password_attempts === "1") {
                                //     localStorage.removeItem("password_attempts")
                                //     dispatch(
                                //         addQuestion({ id: uniqueId, question: replaceAllWithAsterisks(message), answer: "", isTyping: "Typing" })
                                //     );
                                //     handleAnswerResponse(uniqueId, replaceAllWithAsterisks(message), "It appears that your password is incorrect. please try again!")
                                // }
                            } else {
                                localStorage.setItem("chat_access_token", result?.auth_info?.access_token)
                                setChatToken(result?.auth_info.access_token)
                                setTest("")
                                dispatch(
                                    addQuestion({ id: uniqueId, question: replaceAllWithAsterisks(suggestion), answer: "", isTyping: "Typing" })
                                );
                                setError(false);
                                try {
                                    const { result, error } = await getAnswerTest(encodeURIComponent(botLoginQue), Client, botId ? botId : "", localStorage.getItem("chatUserName"), 
                                    // userHandler, 
                                    false);
                                    if (error) {
                                        throw error
                                    }
                                    if (result?.error) {
                                        throw result.error
                                    }
                                    setTypePassword(false)
                                    localStorage.setItem('lastBotQuestion', String(Date.now()));
                                    // setOutputMessage(response);
                                    localStorage.setItem("botId", result.conversation_id)
                                    handleAnswerResponse(uniqueId, replaceAllWithAsterisks(suggestion), `Thank you for logging in.\n${result.answer}`)
                                    dispatch(setSuggestionList(result.suggested_questions))
                                    // setTimeout(() => {
                                    //     handleAnswerResponse("", message, result.answer)
                                    // }, 1000)
                                } catch (error: any) {
                                    dispatch(
                                        updateQuestion({
                                            id: uniqueId,
                                            question: replaceAllWithAsterisks(suggestion),
                                            answer: error,
                                            isTyping: "Done",
                                            productType: "product_search",
                                        })
                                    );
                                    handleSpeak(error, uniqueId)
                                    setTypePassword(false)
                                    dispatch(handleAnswerCalling(false));
                                    return {};
                                }
                            }
                        } catch (error: any) {
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: suggestion,
                                    answer: error,
                                    isTyping: "Done",
                                    productType: "product_search",
                                })
                            );
                            handleSpeak(error, uniqueId)
                            dispatch(handleAnswerCalling(false));
                            return {};
                        }
                    }
                }
                else {
                    try {
                        const { result, error } = await getAnswerTest(encodeURIComponent(suggestion), Client, botId ? botId : "", chatToken?.length !== 0 ? localStorage.getItem("chatUserName") : "", 
                        // userHandler, 
                        false);
                        // const { result, error } = await getAnswer(encodeURIComponent(message), Client, botId ? botId : "", chatToken.length !== 0 ? localStorage.getItem("chatUserName") : "");
                        if (error) {
                            throw error
                        }
                        if (result?.error) {
                            throw result.error
                        }
                        localStorage.setItem('lastBotQuestion', String(Date.now()));
                        localStorage.setItem("botId", result.conversation_id)
                        if (result?.answer === "PER_INFO") {
                            dispatch(handleBotLoginQue(suggestion))
                            dispatch(setSuggestionList([]));
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: suggestion,
                                    answer: "Please provide me your Email Id!",
                                    isTyping: "Done",
                                    productType: "product_search"
                                })
                            );
                            handleSpeak("Please provide me your Email Id!", uniqueId)
                            setError(true);
                            dispatch(handleAnswerCalling(false));
                        } else {
                            if (result?.is_recommend) {
                                if (result?.message !== null && result?.message !== "") {
                                    dispatch(
                                        updateQuestion({
                                            id: uniqueId,
                                            question: suggestion,
                                            answer: result?.message,
                                            isTyping: "Done",
                                            is_file: false,
                                            productType: "product_recommendation",
                                            products: result.answer,
                                        })
                                    );
                                    handleSpeak(result?.message, uniqueId)
                                    dispatch(setSuggestionList(result.suggested_questions))
                                    dispatch(handleAnswerCalling(false));
                                } else {
                                    dispatch(
                                        updateQuestion({
                                            id: uniqueId,
                                            question: suggestion,
                                            answer: "Certainly! Here are some suggestions:",
                                            isTyping: "Done",
                                            is_file: false,
                                            productType: "product_recommendation",
                                            products: result.answer,
                                        })
                                    );
                                    handleSpeak("Certainly! Here are some suggestions:", uniqueId)

                                    dispatch(handleAnswerCalling(false));
                                }
                                dispatch(setSuggestionList(result.suggested_questions))
                            } else if (result?.is_cart) {
                                dispatch(setSuggestionList(result.suggested_questions))
                                // Assuming cartProducts is an array of objects with a unique 'id'
                                const newProducts = result.answer.products_added;
                                const sameProducts = newProducts.filter(
                                    (newProd: any) => cartProducts.some((existingProd: any) => existingProd.code === newProd.code)
                                );
                                const diffProducts = newProducts.filter(
                                    (newProd: any) => cartProducts.every((existingProd: any) => existingProd.code !== newProd.code)
                                );
                                if (sameProducts.length > 0) {
                                    const manyReturn = (many: string, much: string, products: any) => {
                                        if (products.length > 1) {
                                            return many
                                        } else {
                                            return much
                                        }
                                    }
                                    const getQuantityText = (products: any[]) => {
                                        if (products.length === 1 && products[0].quantity && products[0].quantity !== 0 && products[0].quantity !== "" && products[0].quantity !== null && products[0].quantity !== undefined) {
                                            return ` along with **${products[0].quantity}** more quantity`;
                                        }
                                        return "";
                                    }
                                    const quantityText = getQuantityText(sameProducts);
                                    if (diffProducts.length === 0) {
                                        dispatch(
                                            updateQuestion({
                                                id: uniqueId,
                                                question: suggestion,
                                                answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`,
                                                isTyping: "Done",
                                                is_file: result.is_file,
                                                productType: "product_search"
                                            })
                                        );
                                        handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`, uniqueId)
                                        // Merge products: add quantities for existing products
                                        const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                        setCartsProduct(mergedProducts);
                                        localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                                    } else {
                                        dispatch(
                                            updateQuestion({
                                                id: uniqueId,
                                                question: suggestion,
                                                answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`,
                                                isTyping: "Done",
                                                is_file: result.is_file,
                                                productType: "product_search"
                                            })
                                        );
                                        handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`, uniqueId)
                                        // Merge products: add quantities for existing products, add new products
                                        const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                        setCartsProduct(mergedProducts);
                                        localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                                    }
                                    dispatch(handleAnswerCalling(false));
                                } else {
                                    dispatch(
                                        updateQuestion({
                                            id: uniqueId,
                                            question: suggestion,
                                            answer: result.message,
                                            isTyping: "Done",
                                            is_file: result.is_file,
                                            productType: "product_search"
                                        })
                                    );
                                    handleSpeak(result?.message, uniqueId)

                                    // Merge products: add quantities for existing products, add new products
                                    const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                                    setCartsProduct(mergedProducts);
                                    localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                                    dispatch(handleAnswerCalling(false));
                                }
                            } else {
                                dispatch(setSuggestionList(result.suggested_questions))
                                if (localStorage.getItem("clientName") !== "InzaloEMS") {
                                    dispatch(
                                        updateQuestion({
                                            id: uniqueId,
                                            question: suggestion,
                                            answer: result.answer,
                                            isTyping: "Done",
                                            is_file: result.is_file,
                                            productType: "product_search"
                                        })
                                    );
                                    handleSpeak(result?.answer, uniqueId)
                                    dispatch(handleAnswerCalling(false));
                                } else {
                                    dispatch(
                                        updateQuestion({
                                            id: uniqueId,
                                            question: suggestion,
                                            answer: result.answer,
                                            isTyping: "Done",
                                            is_file: result.is_file,
                                            productType: "product_search"
                                        })
                                    );
                                    handleSpeak(result?.answer, uniqueId)
                                    dispatch(handleAnswerCalling(false));

                                }
                            }
                        }
                    } catch (error: any) {
                        dispatch(setSuggestionList([]));
                        if (error === "Need to login") {
                            dispatch(handleBotLoginQue(suggestion))
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: suggestion,
                                    answer: "Please provide me your Email Id!",
                                    isTyping: "Done",
                                    productType: "product_search"
                                })
                            );
                            handleSpeak("Please provide me your Email Id!", uniqueId)
                            dispatch(handleAnswerCalling(false));
                            setError(true);
                        } else {
                            // Handle other errors
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: suggestion,
                                    answer: error,
                                    isTyping: "Done",
                                    productType: "product_search"
                                })
                            );
                            handleSpeak(error, uniqueId)
                            dispatch(handleAnswerCalling(false));
                        }
                        return {};
                    }
                }
            }
        }
        // }



    }
    const handleButtonClick = () => {
        // Trigger the file input when the button is clicked
        fileInputRef.current.click();
    };
    const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
        "text/plain", // txt
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
        "application/vnd.ms-excel", // xls
        "text/csv" // csv
    ];

    const handleBrowseFiles = async (e: any) => {
        const file = e?.target?.files[0];
        let botId = localStorage.getItem("botId") || "";
        if (file) {
            if (allowedTypes.includes(file?.type)) {
                const maxSize = 7 * 1024 * 1024; // 100 MB in bytes
                if (file?.size > maxSize) {
                    toast.error('Please upload a doc file smaller than 7 MB.', {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                    fileInputRef.current.value = null
                    return;
                }
                const base64String = await myconst.fileToBase64(file);
                const properbase64 = await myconst.manipulateBase64Data(base64String);
                dispatch(handleAnswerCalling(true));
                const uniqueId = uuidv4();
                dispatch(
                    addQuestion({ id: uniqueId, question: "File is uploaded successfully", answer: "", isTyping: "Typing" })
                );
                let Client: string | null = "";
                const env = localStorage.getItem("clientName")
                if (window.location.origin === 'https://ron.rysun.in:3001' && env === "ron_prod") {
                    Client = "frida_prod"
                } else if (window.location.origin !== 'https://ron.rysun.in:3001' && (env === "ron_stage" || env === "ron_dev")) {
                    Client = "frida"
                } else {
                    if (localStorage.getItem("envParam") === "Firstwatch") {
                        Client = "Firstwatch"
                    } else {
                        Client = "frida_prod"
                    }
                }
                const body: any = {
                    client_env: localStorage.getItem('clientName'),
                    bot_name: Client,
                    csv_file: properbase64
                }
                if (botId !== "") {
                    body.conversation_id = botId
                }
                try {
                    const { result, error } = await vc_csv_upload(body)
                    // const { result, error } = await getAnswer(encodeURIComponent(message), Client, botId ? botId : "", chatToken.length !== 0 ? localStorage.getItem("chatUserName") : "");
                    if (error) {
                        throw error
                    }
                    if (result?.error) {
                        throw result.error
                    }
                    localStorage.setItem('lastBotQuestion', String(Date.now()));
                    localStorage.setItem("botId", result.conversation_id)
                    dispatch(handleBotLoginQue(message))
                    fileInputRef.current.value = null
                    const newProducts = result.results.products_added;
                    const sameProducts = newProducts.filter(
                        (newProd: any) => cartProducts.some((existingProd: any) => existingProd.code === newProd.code)
                    );
                    const diffProducts = newProducts.filter(
                        (newProd: any) => cartProducts.every((existingProd: any) => existingProd.code !== newProd.code)
                    );
                    if (sameProducts.length > 0) {
                        const manyReturn = (many: string, much: string, products: any) => {
                            if (products.length > 1) {
                                return many
                            } else {
                                return much
                            }
                        }
                        const getQuantityText = (products: any[]) => {
                            if (products.length === 1 && products[0].quantity && products[0].quantity !== 0 && products[0].quantity !== "" && products[0].quantity !== null && products[0].quantity !== undefined) {
                                return ` along with ${products[0].quantity} more quantity`;
                            }
                            return "";
                        }
                        const quantityText = getQuantityText(sameProducts);
                        if (diffProducts.length === 0) {
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: "File is uploaded successfully",
                                    answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`,
                                    isTyping: "Done",
                                    is_file: result.is_file,
                                    productType: "product_search"
                                })
                            );
                            handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.`, uniqueId)
                        } else {
                            dispatch(
                                updateQuestion({
                                    id: uniqueId,
                                    question: "File is uploaded successfully",
                                    answer: `The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`,
                                    isTyping: "Done",
                                    is_file: result.is_file,
                                    productType: "product_search"
                                })
                            );
                            handleSpeak(`The ${manyReturn('products', 'product', sameProducts)} **${sameProducts.map((product: any) => product.name).join(', ')}** ${manyReturn('have', 'has', sameProducts)} already been added to the cart${quantityText}.\n\n---\n\nGreat choice! The following ${manyReturn('products', 'product', diffProducts)} ${manyReturn('have', 'has', diffProducts)} been added to your cart: **${diffProducts.map((product: any) => product.name).join(', ')}**`, uniqueId)
                            // Merge products: add quantities for existing products, add new products
                            const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                            setCartsProduct(mergedProducts);
                            localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                        }
                        dispatch(handleAnswerCalling(false));
                    } else {
                        dispatch(setSuggestionList(result.suggested_questions))
                        dispatch(
                            updateQuestion({
                                id: uniqueId,
                                question: "File is uploaded successfully",
                                answer: result.results.message,
                                isTyping: "Done",
                                is_file: result.is_file,
                                productType: "product_search"
                            })
                        );
                        handleSpeak(result.results.message, uniqueId)
                        // Merge products: add quantities for existing products, add new products
                        const mergedProducts = mergeProductsWithCart(newProducts, cartProducts);
                        setCartsProduct(mergedProducts);
                        localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(mergedProducts))
                        dispatch(handleAnswerCalling(false));
                    }
                } catch (error: any) {
                    fileInputRef.current.value = null
                    dispatch(
                        updateQuestion({
                            id: uniqueId,
                            question: "File is uploaded successfully",
                            answer: error,
                            isTyping: "Done",
                            productType: "product_search"
                        })
                    );
                    handleSpeak(error, uniqueId)
                    dispatch(handleAnswerCalling(false));
                }
            } else {
                toast.error("File is not supported", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                fileInputRef.current.value = null
            }
        }
    }

    const getStyledRecommendations = async (product: Product) => {
        // dispatch(handBotleLoader(true));
        setActiveIndexStyledProduct(0);
        const data = {
            product_id: product?.code,
            user_name: localStorage.getItem("username"),
        }
        try {
            const { result, error } = await getRecommendationsStyleIdeas(data);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setStyledIdeaProducts(result.results)
            // dispatch(handBotleLoader(false));
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            if (error === 'something went wrong') {
                setStyledIdeaProducts('something went wrong')
            }
            dispatch(handBotleLoader(false));
        }
    }

    const getBundlingSuggestion = async (product: Product) => {
        // dispatch(handBotleLoader(true));
        setActiveIndexBundleProduct(0)
        const data = {
            product_id: product?.code,
            user_name: localStorage.getItem("username"),
        }
        try {
            const { result, error } = await bundlingSuggestion(data);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            // setBundlingSuggestionProducts(result)
            setBundlingSuggestionProducts(result.results)
            // dispatch(handBotleLoader(false));
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            dispatch(handBotleLoader(false));
        }
    }

    const customStyleAndBundling = async (product: Product) => {
        setBundlingSuggestionProducts([]);
        setStyledIdeaProducts([]);
        dispatch(handBotleLoader(true));
        await getStyledRecommendations(product)
        await getBundlingSuggestion(product)
        dispatch(handBotleLoader(false));
    }

    const hanldeProductDetail = (product: Product, products: Product[]) => {
        setProductList(products)
        setSingleProduct(product)
        // customStyleAndBundling(product)
    }
    // Function to get the active product

    useEffect(() => {
        if (productCompareList?.length > 0) {
            setAddedCompare("Added to Compare")
        }

        setTimeout(() => {
            setAddedCompare("")
        }, 2000)
    }, [productCompareList])
    const comparisonColumn = (list: Product[]) => {
        return list.map((li: Product, index: number) => {
            if (index < 3) {
                return (
                    <div className="compare-col" key={index}>
                        <div className="compare-top">
                            {list?.length > 1 &&
                                <i className="remove-product" onClick={() => removeProductFromCompareList(li.code)}><img src={cancelIcon} alt="close" /></i>
                            }
                            <figure>
                                <img src={li.image} alt={li.name} />
                            </figure>
                            <div className="pro-sm-info">
                                <p>{li.name}</p>
                                <strong>${li.price}</strong>
                                <div className="pro-review"><i><img src={StarFill} alt="StarFill" /></i>{li.rating}</div>
                                <p>Delivery By Tomorrow <span className="green-txt">Free</span></p>
                            </div>
                        </div>
                        <div className="pro-seprator">
                            Highlights
                        </div>
                        <div className="compare-bottom">
                            <p>128 GB ROM</p>
                            <p>15.49 cm (6.1 inch) Super Retina XDR Display</p>
                            <p>48MP + 12MP Dual Rear Camera</p>
                            <p>12MP Front Camera</p>
                            <p>A16 Bionic Chip, 6 Core Processor Hexa Core</p>
                            <p>iOS 17</p>
                            <p>1 Year Warranty for Phone and 6 months warranty for In-box</p>
                        </div>
                    </div>
                )
            }
        })

    }
    const removeProductFromCompareList = (nameToRemove: string) => {
        const newData = productCompareList.filter((item: any) => item.code !== nameToRemove)
        setProductCompareList(newData);
    };
    const removeCheckedProducts = () => {
        const updatedProducts = productCompareList.filter(
            (product: any) => !checked.some(
                (removeProduct: string) => removeProduct === product.code
            )
        );
        setProductCompareList(updatedProducts);
        setToggleAddProducts(false);
        if (checked?.length === 3) {
            setCurrentActivePage("detail")
        }
        setChecked([])
    }
    const handlePageChange = (e: any) => {
        if (e.page < productList?.length && e.page > -1) {
            const selectedProduct = productList[e.page];
            setSingleProduct(selectedProduct);
            setActiveIndex(e.page);
            dispatch(resetProductPageQuestion());
            setBundlingSuggestionProducts([]);
            setStyledIdeaProducts([]);
            setAddToCartBtnName("Add to Cart");

            if (selectedProduct.code !== lastProductId) {
                setLastProductId(selectedProduct.code);
                // customStyleAndBundling(selectedProduct);
            }
        }
    };
    const handleBundleProductClick = async (product: Product) => {
        dispatch(handBotleLoader(true));
        dispatch(resetProductPageQuestion());
        setAddToCartBtnName("Add to Cart");
        setActiveIndexStyledProduct(0)
        if (productDetailPageRef.current) {
            productDetailPageRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
        setProductList([product])
        setSingleProduct(product)
        const matchedIndex = ([product]).findIndex(
            (item: any) => item.code === product.code
        );

        if (matchedIndex !== -1) {
            setActiveIndex(matchedIndex);
        } else {
            setActiveIndex(activeIndex);
        }
        if (product.code !== lastProductId) {
            setLastProductId(product.code);
            // customStyleAndBundling(product);
        }
    }
    const BundlingItem = (product: Product) => {
        return (
            <div className={`product-card`} id={product.code}>
                <div className="product-card-wrap" onClick={() => handleBundleProductClick(product)}>
                    <figure>
                        <span><ImageWithFallback src={product.image !== null ? product.image : defaultImg} fallbackSrc={defaultImg} alt={product.name} /></span>
                        <figcaption><p title={product.name}>{product.name?.length > 20 ? `${product.name.slice(0, 20)}...` : product.name}</p><i><img src={LinkIconWhite} alt="link-icon" /></i></figcaption>
                    </figure>
                </div>
            </div>
        )
    }

    const handleStyledProductClick = async (product: Product) => {
        dispatch(handBotleLoader(true));
        dispatch(resetProductPageQuestion());
        setAddToCartBtnName("Add to Cart");
        setActiveIndexStyledProduct(0)
        if (productDetailPageRef.current) {
            productDetailPageRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
        setProductList([product])
        setSingleProduct(product)
        const matchedIndex = ([product]).findIndex(
            (item: any) => item.code === product.code
        );

        if (matchedIndex !== -1) {
            setActiveIndex(matchedIndex);
        } else {
            setActiveIndex(activeIndex);
        }
        if (product.code !== lastProductId) {
            setLastProductId(product.code);
            // customStyleAndBundling(product);
        }
    }

    const ItemTemplate = React.memo(({ productGroup, singleProduct }: any) => (
        <div className="style-recommendation">
            <div className="product-top">
                <figure>
                    <ImageWithFallback
                        src={singleProduct?.image !== null ? singleProduct?.image : defaultImg}
                        alt={singleProduct?.name}
                        fallbackSrc={defaultImg}
                        styles={{ width: '100%', height: 'auto' }}
                    />
                </figure>
            </div>
            <div className="recommendation-section">
                {productGroup?.map((product: Product, index: number) => (
                    <div key={index} className="single-recommendation" onClick={() => handleStyledProductClick(product)}>
                        <figure>
                            <ImageWithFallback
                                src={product?.image !== null ? product?.image : defaultImg}
                                alt={product?.name}
                                fallbackSrc={defaultImg}
                                styles={{ width: '60px', height: '60px' }}
                            />
                        </figure>
                        <p title={product.name}>{product.name}</p>
                        <h6>${product.price}</h6>
                    </div>
                ))}
            </div>
        </div>
    ));

    const carouselComponent = useMemo(() => {
        return (
            <div className="style-recommendation-container">
                <Carousel
                    page={activeIndexStyledProduct}
                    onPageChange={(e) => setActiveIndexStyledProduct(e.page)}
                    value={chunkedStyledIdeaProducts}
                    numScroll={1}
                    numVisible={1}
                    responsiveOptions={[]}
                    showNavigators={false}
                    showIndicators={styledIdeaProducts?.length > 3}
                    itemTemplate={(productGroup: Product[]) => (
                        <ItemTemplate productGroup={productGroup} singleProduct={singleProduct} />
                    )}
                />
            </div>
        );
    }, [styledIdeaProducts,
        // chunkedStyledIdeaProducts,
        activeIndexStyledProduct,
        singleProduct,
    ]); // Only recomputes when styledIdeaProducts changes

    const handleAddToCart = (newProduct: any) => {
        if (!cartProducts.some((product: any) => product.code === newProduct.code)) {
            const productWithQuantity = { ...newProduct, quantity: newProduct.quantity || 1 };
            setCartsProduct([...cartProducts, productWithQuantity]);
            const finalArray = [...cartProducts, productWithQuantity]
            localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(finalArray))
        } else {
            setCartPageVisible(true)
            setProductCartList([])
        }
    }

    // Helper function to merge products from API with existing cart products
    const mergeProductsWithCart = (newProducts: any[], existingCartProducts: any[]) => {
        const updatedCart = existingCartProducts.map((existingProduct: any) => {
            const matchingNewProduct = newProducts.find((newProd: any) => newProd.code === existingProduct.code);
            if (matchingNewProduct) {
                // Add quantities: existing quantity + new quantity from API
                const existingQuantity = existingProduct.quantity || 1;
                const newQuantity = matchingNewProduct.quantity || 1;
                return { ...existingProduct, quantity: existingQuantity + newQuantity };
            }
            return existingProduct;
        });

        // Add products that don't exist in cart yet
        const productsToAdd = newProducts.filter(
            (newProd: any) => !existingCartProducts.some((existingProd: any) => existingProd.code === newProd.code)
        ).map((product: any) => ({ ...product, quantity: product.quantity || 1 }));

        return [...updatedCart, ...productsToAdd];
    }

    const updateQuantity = (productCode: string, change: number) => {
        const updatedProducts = cartProducts.map((product: any) => {
            if (product.code === productCode) {
                const newQuantity = Math.max(1, (product.quantity || 1) + change);
                return { ...product, quantity: newQuantity };
            }
            return product;
        });
        setCartsProduct(updatedProducts);
        localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(updatedProducts));
    }
    const formatUSD = (value: number) =>
        new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(value);
    // const formatUSD = (value: number) =>
    //     new Intl.NumberFormat('en-IN', {
    //         style: 'currency',
    //         currency: 'INR',
    //     }).format(value);
    const productDetailPage = () => {
        const addToCompare = () => {
            if (productCompareList?.length === 0) {
                const tempProduct = productList[activeIndex]
                setProductCompareList([tempProduct])
            } else {
                setCurrentActivePage("compare")
            }
        }
        const tryWithAI = () => {
            setCurrentActivePage("AI")
        }
        // const handleAddToCart = (product: any) => {
        //     // setAddToCart("Thanks for adding the product to the demo cart!");
        //     // setAddToCartBtnName("Added to Cart")
        //     // setTimeout(() => {
        //     //     setAddToCart("")
        //     // }, 2000)
        //     setProductList([]);
        //     setProductCompareList([]);
        //     setActiveIndexBundleProduct(0);
        //     setActiveIndexStyledProduct(0);
        //     setAddToCartBtnName("Add to Cart");
        //     dispatch(resetProductPageQuestion());
        //     dispatch(addOrRemoveObjectForAddToCart(product));
        //     const uniqueId = uuidv4();
        //     const uniqueId2 = uuidv4();
        //     dispatch(
        //         addQuestion({ id: uniqueId, question: "", answer: `We have added the ${product.title} to your cart.`, isTyping: "Done", isCsv: "", productType: "product_search" })
        //     );
        //     setTimeout(() => {
        //         dispatch(
        //             addQuestion({ id: uniqueId2, question: "", answer: `Based on your preference for the ${product?.title}, you might be interested in exploring related products. Would you like to view them?`, isTyping: "Done", isCsv: "", productType: "product_search" })
        //         );
        //     }, 1000)
        // }
        const updatedProducts = productList?.filter(
            (product: any) => !productCompareList.some(
                (removeProduct: Product) => removeProduct.code === product.code
            )
        );
        const handleChecked = (link: string) => {
            if (checked.includes(link)) {
                setChecked(checked.filter((ch: string) => ch !== link))
            } else {
                setChecked([...checked, link])
            }
        }
        return (<>
            {(productList?.length > 0 || productCartList.length > 0) &&
                <>
                    {currentActivePage === 'detail' ?
                        <div className={`product-detail-wrap`} style={{ zIndex: "100" }}>
                            <div className="product-details" ref={productDetailPageRef}>
                                <i className="close-product" onClick={() => {
                                    if (productCartList.length === 0) {
                                        setProductList([]);
                                        setProductCompareList([]);
                                        setActiveIndexBundleProduct(0);
                                        setActiveIndexStyledProduct(0);
                                        scrollToBottom();
                                        setAddToCartBtnName("Add to Cart");
                                        dispatch(resetProductPageQuestion());
                                    } else {
                                        dispatch(resetProductPageQuestion());
                                        setCartPageVisible(true);
                                        setProductCartList([]);
                                    }
                                }}><img src={CloseIcon} alt="close" /></i>
                                {productCartList.length === 0 ?
                                    <Carousel page={activeIndex} showIndicators={false} showNavigators={productList?.length > 1 ? true : false} value={productList} onPageChange={handlePageChange} numScroll={1} numVisible={1} itemTemplate={productDetailTemplate} />
                                    : <Carousel page={0} showIndicators={false} showNavigators={productCartList.length > 1 ? true : false} value={productCartList} onPageChange={handlePageChange} numScroll={1} numVisible={1} itemTemplate={productDetailTemplate} />
                                }
                                {/* <div className="product-top">
                    <figure>
                        <img src={obj.product.link} alt={obj.product.title} />
                    </figure>
                </div> */}
                                {productList?.length > 0 && productCartList.length === 0 &&
                                    <div className="product-bottom">
                                        {/* <div className="product-name">Apple iPhone 16 (Ultramarine, 128 GB)</div> */}
                                        <div className="product-name">{productList[activeIndex]?.name !== null ? productList[activeIndex]?.name : "N/A"}</div>
                                        {/* <strong>${productList[activeIndex]?.price !== null ? productList[activeIndex]?.price : ""}</strong> */}
                                        <strong>{productList[activeIndex]?.price !== null ? formatUSD(productList[activeIndex]?.price) : ""}</strong>
                                        {/* Ratting starts  */}
                                        {/* <div className="star-review d-flex align-items-center">
                                            {renderStars(parseFloat(productList[activeIndex]?.rating))}
                                            <span className="rating ml-1">{productList[activeIndex]?.rating}</span>
                                            <a href="javascript:void(0)" style={{ cursor: "default" }} className="review-rating">{productList[activeIndex]?.no_of_rating} Ratings</a>
                                        </div> */}
                                        <div className="product-list-details">
                                            {/* <li><p>Color: <b>{productList[activeIndex]?.baseColour}</b></p></li> */}
                                            {/* <li><p>Storage: <b>128 GB</b></p></li> */}
                                            <li><p>Designer: <b>{productList[activeIndex]?.designer}</b></p></li>
                                            <li><p>Brand Collection: <b>{productList[activeIndex]?.brand_collection}</b></p></li>
                                            <li><p>Finish: <b>{productList[activeIndex]?.selected_finish}</b></p></li>
                                            <li><p><b>Description</b>: {productList[activeIndex]?.description !== null ? productList[activeIndex]?.description : "N/A"}</p></li>
                                        </div>
                                    </div>
                                }
                                {productCartList?.length > 0 &&
                                    <div className="product-bottom">
                                        {/* <div className="product-name">Apple iPhone 16 (Ultramarine, 128 GB)</div> */}
                                        <div className="product-name">{productCartList[0]?.name !== null ? productCartList[0]?.name : "N/A"}</div>
                                        {/* <strong>${productCartList[0]?.price !== null ? productCartList[0]?.price : ""}</strong> */}
                                        <strong>{productCartList[0]?.price !== null ? formatUSD(productCartList[0]?.price) : ""}</strong>
                                        {/* <div className="star-review d-flex align-items-center">
                                            {renderStars(parseFloat(productCartList[0]?.rating))}
                                            <span className="rating ml-1">{productCartList[0]?.rating}</span>
                                            <a href="javascript:void(0)" style={{ cursor: "default" }} className="review-rating">{productCartList[0]?.no_of_rating} Ratings</a>
                                        </div> */}
                                        <div className="product-list-details">
                                            <li><p>Designer: <b>{productCartList[0]?.designer}</b></p></li>
                                            <li><p>Brand Collection: <b>{productCartList[0]?.brand_collection}</b></p></li>
                                            <li><p>Finish: <b>{productCartList[0]?.selected_finish}</b></p></li>
                                            <li><p><b>description</b>: {productCartList[0]?.description !== null ? productCartList[0]?.description : "N/A"}</p></li>
                                        </div>
                                    </div>
                                }
                                {addedCompare !== '' && <span className="compare-toast">{addedCompare}</span>}
                                {addToCart !== '' && <span className={`compare-toast large-box ${(productList[activeIndex]?.details === null) ? "compare-toast-empty-description" : ""}`}>{addToCart}</span>}
                                <ul className="pro-action-btn d-flex justify-content-center">
                                    {/* <li style={{ pointerEvents: "none", opacity: "0.5" }}>
                                        <button className="outline-btn" style={{ border: "none", background: "#e1e1e1" }} onClick={addToCompare}>{productCompareList?.length === 0 ? "Add" : "Go"} to Compare</button>
                                    </li> */}
                                    <li>
                                        <button onClick={tryWithAI} className="outline-btn glow-btn">Visual-to-Motion AI</button>
                                        {/* <button onClick={tryWithAI} className="outline-btn glow-btn">Try with AI</button> */}
                                    </li>
                                    <li>
                                        {productList?.length > 0 && productCartList.length === 0 ?
                                            <button type="button" className={`outline-active-btn ${(addToCartBtnName === "Added to Cart") ? "active-cart-btn" : ""}`} onClick={() => handleAddToCart(productList[activeIndex])}>{cartProducts.some((product: any) => product?.code === productList[activeIndex]?.code) ? 'Go' : 'Add'} to Cart</button>
                                            : <button type="button" className={`outline-active-btn ${(addToCartBtnName === "Added to Cart") ? "active-cart-btn" : ""}`} onClick={() => handleAddToCart(productCartList[0])}>Go to Cart</button>
                                        }
                                    </li>
                                </ul>
                                {/* {styledIdeaProducts !== "No Style idea found" && styledIdeaProducts !== 'something went wrong' &&
                                    <div className="style-section">
                                        <h3>Style Picks for You</h3>
                                        {carouselComponent}
                                    </div>
                                } */}
                                {/* <div className="style-section">
                                    <h3>Frequently Bought Together</h3>
                                    <div className={`product-slider-wrap`}>
                                        <div className="product-slider bundle">
                                            <Carousel page={activeIndexBundleProduct} className="clg"
                                                onPageChange={(e) => setActiveIndexBundleProduct(e.page)} value={bundlingSuggestionProducts} numScroll={1} showNavigators={bundlingSuggestionProducts?.length > 3 ? true : false} numVisible={3} responsiveOptions={responsiveOptions} itemTemplate={BundlingItem} />
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        :
                        <div className="product-detail-wrap">
                            <div className="product-details">
                                <div className="compare-head">
                                    <h5>Try With AI</h5>
                                    <span className="compare-head-right">
                                        <i><img src={CloseIcon} alt="close" onClick={() => { setCurrentActivePage("detail"); lensInputRef.current.value = null; setRoomImage(""); setVideoImage([]); setRoomImage2("") }} /></i>
                                    </span>
                                </div>
                                <div className="bot-upload-img">
                                    <div className="two-col-row">
                                        <div className="two-col-img">
                                            <img style={{ border: '1px solid #c8c8c8', borderRadius: '6px' }} src={productList[activeIndex]?.image} alt='pro-image' />
                                        </div>
                                        <div className="two-col-img">
                                            <img src={roomImage2 === "" ? uploadVector : roomImage2} alt='upload-image' onClick={handleLensToggle} />
                                            <p><i><img src={infoImg} alt='info-image' /></i>File formats: <b>PNG of </b> 10 MB <b>in size</b>.</p>
                                            <input id='uploadDoc' ref={lensInputRef} type="file" placeholder='Upload document' onChange={handleLensChange} className="d-none" accept=".jpg,.png,.jpeg" name="fileUpload" />
                                        </div>
                                    </div>
                                    <div className="one-col-row" style={{ visibility: videoImage.length > 0 ? 'visible' : 'hidden' }}>
                                        <img src={videoImage[0]?.src} alt='genrated-image' />
                                        <i onClick={() => setOpen(true)}><img src={zoomIn} alt='zoom-in' /></i>
                                    </div>
                                    <div className="retry-btn" onClick={() => { setVideoImage([]); setRoomImage(""); setRoomImage2(""); lensInputRef.current.value = "" }} style={{ visibility: videoImage.length > 0 ? 'visible' : 'hidden' }}>
                                        <a>Try Another Image</a>
                                        {/* <a>Retry</a> */}
                                    </div>
                                </div>
                                <ul className="pro-action-btn">
                                    <li>
                                        <button className="outline-btn" onClick={() => roomUpload(productList[activeIndex]?.image)}>Curate Experience</button>
                                    </li>
                                    <li>
                                        {productList?.length > 0 && productCartList.length === 0 ?
                                            <button type="button" className={`outline-active-btn ${(addToCartBtnName === "Added to Cart") ? "active-cart-btn" : ""}`} onClick={() => handleAddToCart(productList[activeIndex])}>{cartProducts.some((product: any) => product?.code === productList[activeIndex]?.code) ? 'Go' : 'Add'} to Cart</button>
                                            : <button type="button" className={`outline-active-btn ${(addToCartBtnName === "Added to Cart") ? "active-cart-btn" : ""}`} onClick={() => handleAddToCart(productCartList[0])}>Go to Cart</button>
                                        }
                                    </li>
                                </ul>
                                {/* <div className="compare-head">
                                    <h5>Compare</h5>
                                    <span className="compare-head-right">
                                        <i className="add-product" onClick={() => setToggleAddProducts(true)}><img src={ProductAdd} alt="ProductAdd" /></i>
                                        <i><img src={CloseIcon} alt="close" onClick={() => setCurrentActivePage("detail")} /></i>
                                    </span>
                                </div>
                                <div className={`compare-product ${productCompareList?.length === 3 ? 'three-col' : ''}`}>

                                    {comparisonColumn(productCompareList)}
                                    {productCompareList?.length < 2 &&
                                        <div className="compare-col add-new-product">
                                            <div className="compare-top">
                                                <div className="placeholder-img"></div>
                                                <div className="pro-sm-info">
                                                    <div className="btn-area">
                                                        <button className="outline-active-btn" onClick={() => setToggleAddProducts(true)}>Add a Product</button>
                                                    </div>
                                                    <p>NA</p>
                                                </div>
                                            </div>
                                            <div className="pro-seprator">
                                                Highlights
                                            </div>
                                            <div className="compare-bottom">
                                                <p>Storage</p>
                                                <p>Screen Size/ Resolution</p>
                                                <p>Rear Camera</p>
                                                <p>Front Camera</p>
                                                <p>Processor</p>
                                                <p>OS</p>
                                                <p>Warranty</p>
                                            </div>
                                        </div>
                                    }
                                </div> */}
                            </div>
                        </div>
                    }
                    {toggleAddProducts && currentActivePage === 'compare' && productCompareList?.length < 3 &&
                        <div className="product-detail-wrap remove-product similar-product">
                            <div className="product-details">
                                <div className="product-heading">
                                    <h5>Similar Product to Compare</h5>
                                    <i className="close-product"><img src={CloseIcon} onClick={() => { setToggleAddProducts(false); setAddToCartBtnName("Add to Cart"); }} alt="close" /></i>
                                </div>
                                <div className="product-listing">
                                    {updatedProducts.map((product: Product, index: number) => (
                                        <div key={index} className="product-listing-wrap" onClick={() => { setProductCompareList([...productCompareList, product]); setToggleAddProducts(false) }}>
                                            <div className="product-right">
                                                <figure>
                                                    <img src={product?.image} alt={product?.name} />
                                                </figure>
                                                <div className="pro-sm-info">
                                                    <p>{product?.name}</p>
                                                    {/* <p>Apple iPhone 16 (Ultramarine, 128 GB)</p> */}
                                                    <strong>${product?.price}</strong>
                                                    <div className="pro-review"><i><img src={StarFill} alt="StarFill" /></i>4</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    }
                    {toggleAddProducts && currentActivePage === 'compare' && productCompareList?.length === 3 &&
                        <div className="product-detail-wrap remove-product">
                            <div className="product-details">
                                <div className="product-heading">
                                    <h5>Remove one Product to Compare</h5>
                                    <i className="close-product" onClick={() => { setToggleAddProducts(false); setChecked([]); setAddToCartBtnName("Add to Cart"); }}><img src={CloseIcon} alt="close" /></i>
                                </div>
                                <div className="product-listing">
                                    {productCompareList.map((product: Product, index: number) => (
                                        <div className="product-listing-wrap" key={index}>
                                            <div className="product-checkbox">
                                                <Checkbox checked={checked.includes(product.code) ? true : false} onChange={() => handleChecked(product.code)}></Checkbox>
                                            </div>
                                            <div className="product-right">
                                                <figure>
                                                    <img src={product.image} alt={product.name} />
                                                </figure>
                                                <div className="pro-sm-info">
                                                    <p>{product.name}</p>
                                                    {/* <p>Apple iPhone 16 (Ultramarine, 128 GB)</p> */}
                                                    <strong>${product.price}</strong>
                                                    <div className="pro-review"><i><img src={StarFill} alt="StarFill" /></i>4</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <ul className="pro-action-btn">
                                    <li>
                                        <button className="outline-btn" onClick={() => { setChecked([]); setToggleAddProducts(false) }}>Cancel</button>
                                    </li>
                                    <li>
                                        <button onClick={removeCheckedProducts} style={{ opacity: checked?.length === 0 ? "0.5" : "1", pointerEvents: checked?.length === 0 ? "none" : "visible" }} className="outline-active-btn">Remove</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    }
                </>
            }
        </>)
    }
    const handleResponse = (obj: any) => {
        if (obj.productType === "product_recommendation" && obj.products) {
            const tempProducts = obj.products
            return <>
                <div className={`output-message-container`}>
                    {/* {
                        !_.isEmpty(isPreview === "isPreview" ? botLogo : data?.bot_config?.bot_logo)
                            ? <div><span className="chat-img"><img src={`data:image/png;base64,${isPreview === "isPreview" ? botLogo : data?.bot_config?.bot_logo}`} alt="bot-logo" className="bot-logo" /></span></div>
                            : <i className="fa-solid fa-robot"></i>
                    } */}
                    <p style={{ background: isPreview === "isPreview" ? answerBackgroundColor : data?.bot_config?.answer_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>{MarkdownRenderer(obj.answer)}

                        <span className='conversation-section-icon-top'
                            onClick={() =>
                                handleSpeak(
                                    obj?.answer, obj.id
                                )
                            }
                            style={
                                stopId ===
                                    obj.id
                                    ? {
                                        backgroundColor:
                                            '#F1F1F1',
                                        border: '1px solid #404040',
                                        borderRadius:
                                            '50%',
                                        float: 'right',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '25px',
                                        width: '25px',
                                        marginTop: '8px'
                                    }
                                    : { float: 'right', cursor: 'pointer', marginTop: '8px' }
                            }
                        >
                            <img
                                data-tooltip-id='my-tooltip'
                                data-tooltip-content='Text-to-Speech'
                                title='Text to Speech'
                                className='speaker-button'
                                src={speakerIcon}
                                alt='copy-button'

                            />
                        </span>
                    </p>
                </div>
                <div className={`product-slider-wrap `}>
                    <div className="product-slider">
                        <Carousel value={obj.products} numScroll={1} showNavigators={obj.products?.length > 3 ? true : false} numVisible={3} responsiveOptions={responsiveOptions} itemTemplate={(product: any) => productTemplate(product, obj.products)} />
                    </div>
                </div>
                {/* <div className="ai">
                    <i><img src={aiAnim} alt="ai-anim" /></i>
                    <span><img src={aiAnimTxt} alt="ai-anim-txt" /></span>
                </div> */}
            </>
            // return <Carousel value={obj.products} numScroll={1} numVisible={3} responsiveOptions={responsiveOptions} itemTemplate={productTemplate} />
        } else {
            // if (obj.productType === "product_search" && obj.answer) {
            return <div className={`output-message-container`}>
                {/* {
                    !_.isEmpty(isPreview === "isPreview" ? botLogo : data?.bot_config?.bot_logo)
                        ? <div><span className="chat-img"><img src={`data:image/png;base64,${isPreview === "isPreview" ? botLogo : data?.bot_config?.bot_logo}`} alt="bot-logo" className="bot-logo" /></span></div>
                        : <i className="fa-solid fa-robot"></i>
                } */}
                <p style={{ background: isPreview === "isPreview" ? answerBackgroundColor : data?.bot_config?.answer_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>{obj.is_file ? <span>Here is the link to the CSV file:  <Link to="" onClick={() => handleDownloadPdf(obj.answer, obj.file_type)}>Reference Data</Link></span> : MarkdownRenderer(obj.answer)} <span className='conversation-section-icon-top'
                    onClick={() =>
                        handleSpeak(
                            obj?.answer, obj.id
                        )
                    }
                    style={
                        stopId ===
                            obj.id
                            ? {
                                backgroundColor:
                                    '#F1F1F1',
                                border: '1px solid #404040',
                                borderRadius:
                                    '50%',
                                float: 'right',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '25px',
                                width: '25px',
                                marginTop: '8px'
                            }
                            : { float: 'right', cursor: 'pointer', marginTop: '8px' }
                    }
                >
                    <img
                        data-tooltip-id='my-tooltip'
                        data-tooltip-content='Text-to-Speech'
                        title='Text to Speech'
                        className='speaker-button'
                        src={speakerIcon}
                        alt='copy-button'

                    />
                </span>
                </p>
            </div>
        }
    }

    const scrollToBottom = () => {
        // messagesEndRef?.current?.scrollTo({
        //     top: messagesEndRef?.current.scrollHeight,
        //     left: 0,
        //     behavior: 'smooth',
        // })
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }
    // useEffect(() => {
    //     if (userHandler === undefined) {
    //         dispatch(handleIsUserHandler(false));
    //     }
    // }, [userHandler])

    // useEffect(() => {
    //     if (userHandler !== undefined) {
    //         const timer = setTimeout(() => {
    //             setShowSuggestions(true);
    //         }, 2000); // 2 seconds delay

    //         return () => clearTimeout(timer); // cleanup on unmount
    //     }
    //     if (!isUserHandler && isPreview !== "isPreview" && userHandler !== undefined && suggestionList?.length === 0) {
    //         setShowSuggestions(true);
    //     }
    // }, [userHandler]);

    const handleRefresh = async () => {
        // Stop any currently playing audio
        if (currentAudioRef.current) {
            currentAudioRef.current.pause();
            currentAudioRef.current = null;
        }
        dispatch(setStopId(""));

        // setShowSuggestions(false)
        // if (userHandler !== undefined) {
        //     dispatch(handleIsUserHandler(true));
        // } else {
        //     dispatch(handleIsUserHandler(false));
        // }
        dispatch(resetProductPageQuestion())
        dispatch(setSuggestionList([]));
        dispatch(setIsNewConversation("new"))
        dispatch(resetQuestion())
        setTypePassword(false)
        setFollowUP(false);
        setTest("");
        setChatToken("");
        dispatch(controlHandlerState(""));
        setBotProduct("")
        setProductCompareList([])
        setProductList([]);
        setToggleAddProducts(false);
        setChecked([]);
        setCurrentActivePage("detail")
        setLinkIconHover2(LinkIcon);
        setLinkIconHover1(LinkIcon);
        setError(false);
        setMessage("")
        localStorage.removeItem("wrongAttempt");
        localStorage.removeItem("attempt");
        localStorage.removeItem("false_attempt");
        try {
            const { result, error } = await memoryClear();
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            localStorage.removeItem("chatUserName");
            localStorage.removeItem("chat_access_token");
            localStorage.removeItem("botId");
            // toast.success(result.message)
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleBotData = async () => {
        dispatch(handBotleLoader(true));
        let Client: string | null = ""
        const env = localStorage.getItem("clientName")
        if (window.location.origin === 'https://ron.rysun.in:3001' && env === "ron_prod") {
            Client = "frida_prod"
        } else if (window.location.origin !== 'https://ron.rysun.in:3001' && env === "ron_stage") {
            Client = "frida"
        } else {
            Client = env
        }
        try {
            const { result, error } = await getBotConfigurations(Client);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setData(result);
            setBotl(`data:image/png;base64,${result.bot_config.bot_logo}`)
            setAvtarl(`data:image/png;base64,${result.bot_config.avatar_logo}`)
            setFontSize1(result.bot_config.font_size)
            dispatch(handBotleLoader(false));
        } catch (error: any) {
            dispatch(handBotleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
            return {};
        }
    }

    useEffect(() => {
        scrollToBottom();
        setAddToCartBtnName("Add to Cart")
    }, [messages]);
    // }, [messages, showSuggestions]);


    useEffect(() => {
        if (isPreview !== "isPreview") {
            handleBotData()
        }
        // if (botProduct === 'ProductRecommendation') {
        //     setLinkIconHover2(LinkIconWhite);
        // } else if (botProduct === 'ProductSearch') {
        //     setLinkIconHover1(LinkIconWhite);
        // }
    }, [])

    useEffect(() => {
        if (message !== "") {
            inputRef?.current?.focus();
        }
        if (message === "Listening...") {
            inputRef.current.blur();
        }
    }, [message])

    const MarkdownRenderer = (content: any) => {
        return (
            <ReactMarkdown
                components={{
                    // Paragraphs
                    p: ({ node, ...props }) => <p className={styles['markdown-paragraph']} {...props} />,

                    // p: ({ children, ...props }) => {
                    //     const lines = children[0]?.toString()?.split('\n') || [];

                    //     let isFirstLine = true;
                    //     const transformedLines = lines.map((line) => {
                    //         const trimmedLine = line.trim();
                    //         const isDotPresent = trimmedLine.includes('•');
                    //         const hasTextBeforeDot = isDotPresent && trimmedLine.indexOf('•') > 0;

                    //         const shouldBreakLine = hasTextBeforeDot && !isFirstLine;

                    //         isFirstLine = false;
                    //         return shouldBreakLine ? '<br>•' + trimmedLine : line;
                    //     });

                    //     let transformedContent = transformedLines.join('<br>');
                    //     transformedContent = transformedContent.replace(/"([^"]*)"/g, '<b>$1</b>');
                    //     transformedContent = transformedContent.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
                    //     return (
                    //         <p
                    //             className={styles['markdown-paragraph']}
                    //             dangerouslySetInnerHTML={{ __html: transformedContent }}
                    //             {...props}
                    //         />
                    //     );
                    // },
                    //  Headings
                    h1: ({ node, ...props }) => (
                        <h1
                            className={styles['markdown-heading1']}
                            {...props}
                        />
                    ),
                    h2: ({ node, ...props }) => (
                        <h2
                            className={styles['markdown-heading2']}
                            {...props}
                        />
                    ),
                    h3: ({ node, ...props }) => (
                        <h3
                            className={styles['markdown-heading3']}
                            {...props}
                        />
                    ),
                    h4: ({ node, ...props }) => (
                        <h4
                            className={styles['markdown-heading4']}
                            {...props}
                        />
                    ),
                    h5: ({ node, ...props }) => (
                        <h5
                            className={styles['markdown-heading5']}
                            {...props}
                        />
                    ),
                    h6: ({ node, ...props }) => (
                        <h6
                            className={styles['markdown-heading6']}
                            {...props}
                        />
                    ),

                    // Lists
                    ul: ({ node, ...props }) => (
                        <ul
                            className={styles['markdown-unordered-list']}
                            {...props}
                        />
                    ),
                    ol: ({ node, ordered, ...props }) => (
                        <ol
                            className={styles['markdown-ordered-list']}
                            {...props}
                        />
                    ),

                    // List Items
                    li: ({ node, ordered, ...props }) => (
                        <li
                            className={styles['markdown-list-item']}
                            {...props}
                        />
                    ),

                    // Links
                    a: ({ node, ...props }: any) => (
                        <a
                            className={styles['markdown-link']}
                            href={node.href}
                            {...props}
                            target="_blank"
                        >
                            {props.children}
                        </a>
                    ),
                    strong: ({ node, ...props }) => (
                        <strong
                            className={styles['markdown-strong']}
                            {...props}
                        />
                    ),
                    // Custom renderer for bold text
                    // bold: ({ node, ...props }:any) => (
                    //     <b className={styles['markdown-bold']}
                    //         {...props}
                    //     />
                    // ),
                    // Code Blocks styling or auto formatting API response...
                    pre: ({ node, ...props }) => (
                        <pre
                            className={styles['markdown-code-block']}
                            {...props}
                        />
                    ),
                    code: ({ inline, node, ...props }) => {
                        if (inline) {
                            return (
                                <code
                                    className={styles['markdown-inline-code']}
                                    {...props}
                                />
                            );
                        }
                        return (
                            //     <SyntaxHighlighter language="javascript" >
                            //     {props.children}
                            // </SyntaxHighlighter>

                            <p>{props.children}</p>
                        );
                    },

                    // Blockquotes
                    blockquote: ({ node, ...props }) => (
                        <blockquote
                            className={styles['markdown-blockquote']}
                            {...props}
                        />
                    ),

                    // Images
                    img: ({ node, ...props }: any) => (
                        // <img
                        //     className={styles['markdown-image']}
                        //     src={node.src}
                        //     alt={node.alt}
                        //     style={{ maxWidth: "150px" }}
                        //     {...props}
                        // />
                        <ImageWithFallback
                            src={node.src}
                            alt={node.alt}
                            fallbackSrc={defaultImg}
                            styles={{ maxWidth: "150px" }}
                            {...props}
                        />
                    ),

                    // Table Headers
                    th: ({ node, ...props }) => (
                        <th
                            className={styles['markdown-table-header']}
                            style={{ verticalAlign: 'top' }}
                            {...props}
                        />
                    ),

                    // Table Cells
                    td: ({ node, ...props }) => (
                        <td
                            className={styles['markdown-table-cell']}
                            style={{ verticalAlign: 'top' }}
                            {...props}
                        />
                    ),

                    hr: ({ node, ...props }) => (
                        <hr style={{ margin: '0.5rem' }} className={styles['markdown-divider']} {...props} />
                    ),

                    // Add other components and styles as needed
                }}
                remarkPlugins={[remarkGfm]}
            >{content}</ReactMarkdown>
        )
    }

    const downloadBase64File = (base64: string, file_type: string) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters?.length);
        for (let i = 0; i < byteCharacters?.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        // let blob = new Blob([byteArray], { type: 'text/csv' });
        let blob;
        if (localStorage.getItem("clientName") === "InzaloEMS") {
            blob = new Blob([byteArray], { type: file_type });
        } else {
            blob = new Blob([byteArray], { type: 'text/csv' });
        }
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        if (localStorage.getItem("clientName") === "InzaloEMS") {
            link.download = "Reference_Data.xlsx";
        } else {
            link.download = "Reference_Data.csv";
        }
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDownloadPdf = async (answer: string, file_type: string) => {
        downloadBase64File(answer, file_type)
    }

    // const SendButtonClick = () => {
    //     if (botProduct === "ProductRecommendation") {
    //         handleProductRecommendation();
    //     } else if (botProduct === "ProductSearch") {
    //         handleClickMessage()
    //     }
    // }

    const handleBotHeadSearch = () => {
        const uniqueId = uuidv4();
        setTypePassword("")
        setShowPassword(false)
        setTest("");
        setChatToken("");
        setError(false);
        // dispatch(setBotProduct("ProductSearch"));
        setBotProduct("");
        setLinkIconHover1(LinkIconWhite);
        setLinkIconHover2(LinkIcon);
        dispatch(
            addQuestion({
                id: uniqueId,
                question: "Product Search",
                answer: "",
                isTyping: "Typing",
                is_file: false,
                productType: "product_search",
            })
        );
        handleAnswerResponse(uniqueId, "Product Search", "Sure! How can I assist you with your product search?")
    }
    const handleBotHeadRecommendation = () => {
        const uniqueId = uuidv4();
        setTypePassword("")
        setShowPassword(false)
        // dispatch(setBotProduct("ProductRecommendation"));
        setLinkIconHover2(LinkIconWhite);
        setLinkIconHover1(LinkIcon);
        dispatch(
            addQuestion({
                id: uniqueId,
                question: "Product Recommendation",
                answer: "",
                isTyping: "Typing",
                is_file: false,
                productType: "product_search",
            })
        );
        handleAnswerResponse(uniqueId, "Product Recommendation", "Sounds good! Which products would you like to explore today?")
        // Sure! How can I assist you with your product search?
    }

    const handleVoiceIconClicked = () => {
        // Stop any currently playing audio
        if (currentAudioRef.current) {
            currentAudioRef.current.pause();
            currentAudioRef.current = null;
            dispatch(setStopId(""));
        }

        setIsKeyDown(true);
        setMessage('Listening...');
        // dispatch(setQmateValue('Listening...'));
        if (inputbox) {
            inputbox.setAttribute('disabled', true);
        }
        if (sendButton) {
            sendButton.setAttribute('disabled', true);
        }
        handleStartListening();
        inputRef?.current?.focus();
    };

    const [checked, setChecked] = useState<string[]>([]);
    const currentAudioRef = useRef<HTMLAudioElement | null>(null);

    const removeFromCart = (id: string) => {
        // Cookies.remove(`addToCartProducts${localStorage.getItem('username')}`)
        const removedProducts = cartProducts.filter((product: any) => product.code !== id)
        setCartsProduct(removedProducts);
        localStorage.setItem(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(removedProducts))
        // Cookies.set(`addToCartProducts${encodeURI(localStorage.getItem('username') as any)}`, JSON.stringify(removedProducts), { expires: 1000 });
    }
    const logoOFCartBot = 'iVBORw0KGgoAAAANSUhEUgAAACEAAAAkCAYAAAAHKVPcAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKuSURBVHgBzViLcdpAEH13iPEwQAYqCO6AdIA7IBWYdEAHgQpIKgiuwKSC0EFwBagDMUYyTgza7AqdJTQS4ERIeTOgQ9zn3d7e29vDs0uTJ5ecjUvfXJe6KAM8OCU+PzYOdVAgNAjjxLseqliu19RDkZCZswUG/Fm+WsSjJcrC05q+GCJFWUMlXwT+wMshZZ+XygfmyBmNLRaqrVaZJAIibAVcGDzwYudjXH+nZqWRMNgSbqxjFYQtKSyQI3h2Lf7qcN+BJlkat6kVjWN6axrhQmCB/CljyFOjJLAlVuZZColQkXtSZu97KIXErronEJSBWSkkKnh1RrvZVPPCScSXAqEQFm8JCwNTZI24K4eEPlyK/asCsZGAyEIV/hxHvFJA0R5uIU+omDq+RIExK3ZIFO0IGSMq/wqR69ikprWG+mT+szIayODGErlYw8yWxWmltoenufTl8PGAnCGD82Pub3FTayv7ZAP3MTjqURhgJrgwUn3Ccah1xaer+Br6Pr77CivLgo0cUKtF1lBZlbxH6muNe1wKCqNaXQW+kakTcuzi2X/koo0LgH2kH/E5A2IVpVjvNd4ryk077nibTvG/4CxLSP5RUeiyCVuSAhjNPwViB99UMZB2WvGyskqetT2T+OXR52S+es62DbI6L5bRhVldWtKtTnVkEqEkJDGqN9Uos62kkVGwio9o8664jr86GkXJwtCUdy/4wOa8ZkkPUgCddVRn/HZ4tiEBIcsOqHhJvu47RSdpjeMkwp0gQazRVgtZT01v3LK0J819zJL9GhxPfnTQwa1EwGeP7rlDm8v9sPN5VjuPteVqHwRbuoIJ5y/d4DAT5nXW9g0TEfk+uC4wjrnmm50TFyl8AzRMuYD5u4RKBmOxmgYDhzc5rnPetZLceZhMSybD5WFavT/egciGFZVKtAAAAABJRU5ErkJggg=='

    return (
        <>
            <div className={`section-container parent-container ${isPreview === "isPreview" ? "preview-section-container" : ""}`} style={{ width: (productList?.length > 0 || productCartList.length > 0) ? '960px' : '480px' }}>
                <div className="section-header" style={{ background: isPreview === "isPreview" ? headerColor : data?.bot_config?.header_colour }}>
                    <div className="top-head">
                        {
                            !_.isEmpty(isPreview === "isPreview" ? avatarLogo : avtarl)
                                ? <span className="chat-avtar"><img src={isPreview === "isPreview" ? `data:image/png;base64,${avatarLogo}` : `data:image/png;base64,${data?.bot_config.avatar_logo}`} alt="" className="logo-heading preview-logo-heading" /></span>
                                : <span className="chat-avtar"><img src="/chatbot.png" alt="chatbot" className="logo-heading preview-logo-heading" /></span>
                        }
                        <p>
                            {
                                !_.isEmpty(isPreview === "isPreview" ? botName : data?.bot_config?.bot_name)
                                    ? <span>{isPreview === "isPreview" ? botName : data?.bot_config?.bot_name}</span>
                                    : <span>VCC Product Chatter</span>
                            }
                            {
                                !_.isEmpty(isPreview === "isPreview" ? tagline : data?.bot_config?.tagline)
                                    ? <span>{isPreview === "isPreview" ? tagline : data?.bot_config?.tagline}</span>
                                    : <span>Your Product Assistant</span>
                                // : <span>Intelligent self-service solutions</span>
                            }
                        </p>
                    </div>
                    <div className="d-flex align-items-center">
                        <a title="Cart" className="mr-3 c-pointer" style={{ pointerEvents: isPreview === "isPreview" || cartpageVisible ? 'none' : 'visible' }} onClick={() => setCartPageVisible(true)}>
                            <i className="pi pi-shopping-cart p-overlay-badge" style={{ fontSize: '1.4rem', color: 'black' }}>
                                {cartProducts.length > 0 && isPreview !== "isPreview" &&
                                    <Badge value={cartProducts.length} className={cartProducts.length > 9 ? 'my-badge-circle' : "my-badge"}></Badge>
                                }
                            </i>
                        </a>
                        <a title="Clear chat history">
                            <button className="button-section" style={{ pointerEvents: isPreview === "isPreview" || cartpageVisible ? "none" : "auto" }} onClick={() => handleRefresh()}>
                                <img src={chatBotRefresh} alt="chatBotRefresh" />
                            </button>
                        </a>
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    {(productList?.length > 0 || productCartList.length > 0) &&
                        <div style={{ width: '480px', maxWidth: "100%" }}>
                            <div className={`section-body-footer-wrap `} style={{ borderRadius: '0 0 0 25px' }}>
                                <div className="section-body" style={{ height: 'calc(100vh - 197px)' }}>
                                    {productDetailPage()}
                                </div>
                            </div>
                        </div>
                    }
                    <div style={{ width: '480px', maxWidth: "100%" }}>
                        <div className={`section-body-footer-wrap `} style={{ borderRadius: (productList?.length > 0 || productCartList.length > 0) ? '0 0 25px 0' : '0 0 25px 25px' }}>
                            {cartpageVisible ?
                                <div className="section-body prodct-cart-body">
                                    <div className={`product-detail-wrap`} style={{ zIndex: "100" }}>
                                        <div className="product-details" style={{ height: "calc(100vh - 307px)" }}>
                                            <div className="compare-head">
                                                <h5>Your Cart</h5>
                                                <span className="compare-head-right">
                                                    <i><img src={CloseIcon} alt="close" onClick={() => {
                                                        setCartPageVisible(false); if (productList.length === 0) {
                                                            setTimeout(() => {
                                                                scrollToBottom();
                                                            }, 100)
                                                        }
                                                    }} /></i>
                                                </span>
                                            </div>
                                            {cartProducts.length === 0 ?
                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '90%' }}>
                                                    <span>Your cart is empty</span>
                                                    <Button className='outline-active-btn btn-lg mt-2' type="submit" label='Start Shopping' onClick={() => {
                                                        setCartPageVisible(false); setProductList([]); setTimeout(() => {
                                                            scrollToBottom();
                                                        }, 100)
                                                    }}></Button>
                                                </div>
                                                :
                                                <div className="product-cart">
                                                    <DataTable
                                                        value={cartProducts}
                                                        tableStyle={{}}
                                                        emptyMessage=""
                                                        scrollable
                                                        scrollHeight="auto"
                                                    // footer={footer}
                                                    >
                                                        <Column body={(rowData) => (
                                                            <span className="c-pointer" onClick={() => {
                                                                setProductCartList([rowData]); setCartPageVisible(false); setSingleProduct(rowData);
                                                                setCurrentActivePage("detail");
                                                                // customStyleAndBundling(rowData)
                                                            }}>
                                                                <ImageWithFallback
                                                                    src={rowData?.image !== null ? rowData?.image : defaultImg}
                                                                    alt={rowData?.name}
                                                                    fallbackSrc={defaultImg}
                                                                    styles={{ width: 60, objectFit: 'cover', borderRadius: '4px' }}
                                                                />
                                                            </span>
                                                        )} />
                                                        <Column header="Product Name" body={(rowData) => (
                                                            <span className="c-pointer" onClick={() => {
                                                                setProductCartList([rowData]); setCartPageVisible(false); setSingleProduct(rowData);
                                                                setCurrentActivePage("detail")
                                                                // customStyleAndBundling(rowData)
                                                            }} >
                                                                {rowData.name}
                                                            </span>
                                                        )} footer='Grand Total:' footerStyle={{ textAlign: 'right', fontWeight: 'bold' }}></Column>
                                                        {/* <Column field="price" header="Price" body={(rowData) => (<span>{Number(rowData.price).toFixed(2)}</span>)}
                                                footer={`$${cartProducts.reduce((a: any, b: any) => a + (Number(b.price) || 0), 0).toFixed(2)}`} ></Column> */}
                                                        <Column field="price" header="Price" body={(rowData) => (<span>{formatUSD(rowData?.price)}</span>)}
                                                            footer={`${formatUSD(cartProducts.reduce((a: any, b: any) => a + (Number(b?.price) || 0) * (b?.quantity || 1), 0))}`}
                                                            footerStyle={{ textAlign: 'right', fontWeight: 'bold' }}></Column>
                                                        <Column header="Quantity" body={(rowData) => (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        updateQuantity(rowData.code, -1);
                                                                    }}
                                                                    style={{
                                                                        background: 'transparent',
                                                                        border: '1px solid #ddd',
                                                                        borderRadius: '4px',
                                                                        width: '28px',
                                                                        height: '28px',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontSize: '18px',
                                                                        padding: 0
                                                                    }}
                                                                >
                                                                    <i className="pi pi-minus" style={{ fontSize: '12px' }}></i>
                                                                </button>
                                                                <span style={{ minWidth: '30px', textAlign: 'center', fontWeight: 'bold' }}>
                                                                    {rowData.quantity || 1}
                                                                </span>
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        updateQuantity(rowData.code, 1);
                                                                    }}
                                                                    style={{
                                                                        background: 'transparent',
                                                                        border: '1px solid #ddd',
                                                                        borderRadius: '4px',
                                                                        width: '28px',
                                                                        height: '28px',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontSize: '18px',
                                                                        padding: 0
                                                                    }}
                                                                >
                                                                    <i className="pi pi-plus" style={{ fontSize: '12px' }}></i>
                                                                </button>
                                                            </div>
                                                        )} />
                                                        <Column header='Remove' body={(rowData) => (<i onClick={() => removeFromCart(rowData.code)} className="delete-product">
                                                            <img src={DeleteRed} alt="close" />
                                                        </i>)} />
                                                    </DataTable>
                                                </div>
                                            }
                                        </div >
                                        {cartProducts.length !== 0 &&
                                            <div className="d-flex justify-content-center mt-2">
                                                <Button className='outline-active-btn btn-lg' type="submit" label='Proceed to Purchase'></Button>
                                            </div>
                                        }
                                    </div >
                                </div > :
                                <div className={`section-body overflow-auto ${isPreview === "isPreview" ? "preview-section-body" : ""}`} >
                                    {<div className={`output-message-container`}>
                                        {/* {
                            !_.isEmpty(isPreview === "isPreview" ? botLogo : data?.bot_config?.bot_logo)
                                ? <div><span className="chat-img"><img src={`data:image/png;base64,${isPreview === "isPreview" ? botLogo : data?.bot_config?.bot_logo}`} alt="bot-logo" className="bot-logo" /></span></div>
                                : <i className="fa-solid fa-robot"></i>
                        } */}
                                        {
                                            !_.isEmpty(isPreview === "isPreview" ? initialMessage : data?.bot_config?.initial_message)
                                                ? <p className="" style={{ background: isPreview === "isPreview" ? answerBackgroundColor : data?.bot_config?.answer_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>{isPreview === "isPreview" ? initialMessage : data?.bot_config?.initial_message}</p>
                                                : <p className="" style={{ background: isPreview === "isPreview" ? answerBackgroundColor : data?.bot_config?.answer_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>Hi, I'm your Product Assistant AI! What would you like to explore today?</p>
                                            // : <p className="" style={{ background: isPreview === "isPreview" ? answerBackgroundColor : data?.bot_config?.answer_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>Hey 👋, I'm Ron! I am here to help you with any questions you have.</p>
                                        }
                                        {/* {isPreview !== "isPreview" &&
                                            <>
                                                {(userHandler === undefined || isNewConversation === "old") ?
                                                    <p className="" style={{ background: isPreview === "isPreview" ? answerBackgroundColor : data?.bot_config?.answer_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>To enhance your personalized experience, we are assigning unique handles to users. Do you already have your unique handle? Please respond with "Yes" or "No".</p>
                                                    : <p className="" style={{ background: isPreview === "isPreview" ? answerBackgroundColor : data?.bot_config?.answer_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>Welcome back, <b>{userHandler}</b></p>
                                                }
                                            </>
                                        } */}
                                    </div>}
                                    {(isPreview === "isPreview") ?
                                        <div className={`input-message-container `} >
                                            {/* <p style={{ background: isPreview === "isPreview" ? questionBackgroundColor : data?.bot_config?.question_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>Hello how are you
                            </p> */}
                                            {/* <p style={{background: questionBackgroundColor, fontSize: `${fontSize}px`}}>Hope you are doing good!</p> */}
                                        </div>
                                        : messages?.map((obj: any, index: number) => {
                                            return (
                                                <>
                                                    {obj.question && <div className={`input-message-container `} >
                                                        <p style={{ background: isPreview === "isPreview" ? questionBackgroundColor : data?.bot_config?.question_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>{obj.question}</p>
                                                    </div>}
                                                    {obj.isTyping === "Typing"
                                                        ? <div className={`output-message-container`}>
                                                            {/* {
                                                !_.isEmpty(isPreview === "isPreview" ? botLogo : data?.bot_config?.bot_logo)
                                                    ? <div><span className="chat-img"><img src={`data:image/png;base64,${isPreview === "isPreview" ? botLogo : data?.bot_config?.bot_logo}`} alt="" className="bot-logo" /></span></div>
                                                    : <i className="fa-solid fa-robot"></i>
                                            } */}
                                                            <p style={{ background: isPreview === "isPreview" ? answerBackgroundColor : data?.bot_config?.answer_background_colour, fontSize: `${isPreview === "isPreview" ? fontSize : fontSize1}px` }}>
                                                                <span className="jumping-dots">
                                                                    <span className="dot-1"></span>
                                                                    <span className="dot-2"></span>
                                                                    <span className="dot-3"></span>
                                                                </span>
                                                            </p>
                                                        </div>
                                                        : handleResponse(obj)
                                                    }
                                                </>
                                            );
                                        })
                                    }
                                    {messages.length === 0 && isPreview !== "isPreview" &&
                                        // {messages.length === 0 && isPreview !== "isPreview" && userHandler !== undefined &&
                                        <div className="start-suggestion">
                                            <div className='suggested-que'>
                                                <ul className='suggested-que-list'>
                                                    <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Show me affordable decorative wall lights below $1000.') }}><a>Show me affordable decorative wall lights below $1000.</a></li>
                                                    <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Show all lighting products by Thomas O’Brien in the Signature Collection.') }}><a>Show all lighting products by Thomas O’Brien in the Signature Collection.</a></li>
                                                    <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Recommend a Kelly Wearstler chandelier in Aged Iron under 10,000.') }}><a>Recommend a Kelly Wearstler chandelier in Aged Iron under 10,000.</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    }
                                    {/* {isPreview !== "isPreview" && suggestionList?.length === 0 && 
                                        // {!isUserHandler && isPreview !== "isPreview" && userHandler !== undefined && suggestionList?.length === 0 && showSuggestions &&
                                        <div className="start-suggestion-first">
                                            <div className='suggested-que'>
                                                <ul className='suggested-que-list'>

                                                    <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Show me affordable decorative wall lights below $1000.') }}><a>Show me affordable decorative wall lights below $1000.</a></li>
                                                    <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Show all lighting products by Thomas O’Brien in the Signature Collection.') }}><a>Show all lighting products by Thomas O’Brien in the Signature Collection.</a></li>
                                                    <li onClick={() => { dispatch(handleIsUserHandler(true)); handleClickMessageSuggestion('Recommend a Kelly Wearstler chandelier in Aged Iron under 10,000.') }}><a>Recommend a Kelly Wearstler chandelier in Aged Iron under 10,000.</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    } */}
                                    <span ref={messagesEndRef}></span>
                                </div>
                            }
                            <div className="section-footer">
                                {messages?.length > 0 && isPreview !== "isPreview" && !isAnswerCalling && suggestionList?.length > 0 && !cartpageVisible && productList?.length === 0 &&
                                    <div className="suggestion-nav">
                                        {showLeft && (
                                            <button className="nav-btn left" onClick={scrollLeft}>
                                                <img src={leftIcon} alt="left-icon" />
                                            </button>
                                        )}
                                        <div className="suggestion" ref={scrollRef}>
                                            {suggestionList.map((list: string) => (
                                                <div className="list" onClick={() => { dispatch(setSuggestionList([])); handleClickMessageSuggestion(list) }}>{list}</div>
                                            ))}
                                        </div>
                                        {showRight && (
                                            <button className="nav-btn right" onClick={scrollRight}>
                                                <img src={rightIcon} alt="right-icon" />
                                            </button>
                                        )}
                                    </div>
                                }
                                <div className={`input-section ${(typePassword) ? "input-password" : ""}`}>
                                    {/* <i className="pi pi-plus-circle"></i> */}
                                    <input type={!showPassword && typePassword && productList?.length === 0 ? "password" : "text"} autoComplete={(!showPassword && !typePassword) ? 'off' : 'new-password'} onChange={(e) => handleChange(e)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" && message !== "Listening..." && !isAnswerCalling && message.trim() !== "") {
                                                // SendButtonClick();
                                                handleClickMessage();
                                            }
                                        }}
                                        ref={inputRef}
                                        readOnly={message === "Listening..."}
                                        value={message}
                                        placeholder="Ask me anything"
                                        disabled={isPreview === "isPreview" || cartpageVisible ? true : false}
                                    // disabled={isPreview === "isPreview" || botProduct === "" ? true : false}
                                    />
                                    {
                                        typePassword && productList?.length === 0 &&
                                        <span className={`password-toggle3 me-5`} onClick={() => setShowPassword(!showPassword)}>
                                            {!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                                <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                            }
                                        </span>
                                    }
                                    <button disabled={isPreview === "isPreview" || message.trim() === "" ? true : false} style={{ pointerEvents: (message === "" || message === "Listening..." || message.trim() === "" || isAnswerCalling) ? "none" : "visible" }} onClick={handleClickMessage}>
                                        <i className={`first-icon ${message !== "Listening..." && message.trim() !== "" ? 'active-class' : 'inActive-class'}`}
                                        >
                                            <img src={searchSend} alt='send-btn' />
                                        </i>
                                    </button>
                                    {/* {!typePassword && */}
                                    <button disabled={isPreview === "isPreview"}>
                                        {(VoiceSearchFlag === true || VoiceSearchFlag === undefined) && (
                                            <i className={`last-icon ${message !== "" ? 'active-class' : 'inActive-class'}`}><img src={message === "Listening..." ? searchMicActive : searchMic} onClick={handleVoiceIconClicked} alt='mic-btn' title='Search via Voice' /></i>
                                        )}
                                    </button>
                                    {/* } z */}
                                    <button disabled={isPreview === "isPreview"} onClick={handleButtonClick}>
                                        <i className={`active-class third-icon`}><img src={add} alt='mic-btn' title='Search via Voice' /></i>
                                    </button>
                                    <button className="close-voice">
                                        <i><img src={add} /></i>
                                    </button>
                                    {/* <span className="choose-file">
                            <label htmlFor="file-upload">
                                <img src={ChooseIcon} alt="choose-icon" />
                            </label>
                            <input id="file-upload" type="file" />
                        </span> */}
                                    <input id='uploadDoc' ref={fileInputRef} type="file" placeholder='Upload document' onChange={handleBrowseFiles} className="d-none" name="fileUpload" />
                                </div>
                            </div>
                        </div >
                    </div>
                </div>
                {
                    botLoader && (
                        <div className="clip-loader-bot">
                            <div className="loader-spinner"></div>
                        </div>
                    )
                }
            </div>
            <Lightbox
                open={open}
                plugins={[Video]}
                close={() => setOpen(false)}
                slides={videoImage}
            // slides={[
            //     { src: genratedImg },
            //     { src: LightBoxImg },
            //     { src: proImg },
            // ]}
            />
        </>
    )
}

export default ChatBot1;